// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   Input,
//   Button,
//   Modal,
//   Space,
//   message,
//   Tag,
//   Typography,
//   Select,
//   Row,
//   Col,
//   DatePicker,
//   InputNumber,
//   Tabs,
//   Divider,
//   Steps,
//   Radio,
//   Spin
// } from "antd";
// import {
//   PlusOutlined,
//   ReloadOutlined,
//   SearchOutlined,
//   EyeOutlined,
//   CheckOutlined,
//   FilePdfOutlined,
//   CopyOutlined,
// } from "@ant-design/icons";
// import {
//   downloadDevis,
//   duplicate_devis,
//   export_devis,
//   get_devis,
//   getall_devis,
//   merge_devis,
//   toggle_devis,
//   update_devis,
// } from "../../api/devis";
// import { get_ListeRegion } from "../../api/region";
// import { get_all_agences, get_all_users } from "../../api/users";
// import Notification from "../../composants/Notification";
// import "moment/locale/fr";
// import moment from "moment";
// import { get_ListeClients } from "../../api/clients";
// import { getPermissionsFromToken, hasPermission } from "../../utils/utils";


// const { RangePicker } = DatePicker;
// const { Title, Text } = Typography;
// const { Option } = Select;
// const { TabPane } = Tabs;

// const volumetries = [
//   { label: "10 m³", value: "10" },
//   { label: "11 m³", value: "11" },
//   { label: "12 m³", value: "12" },
//   { label: "13 m³", value: "13" },
//   { label: "14 m³", value: "14" },
//   { label: "15 m³", value: "15" },
//   { label: "16 m³", value: "16" },
//   { label: "17 m³", value: "17" },
//   { label: "18 m³", value: "18" },
//   { label: "19 m³", value: "19" },
//   { label: "20 m³", value: "20" },
//   { label: "21 m³", value: "21" },
//   { label: "22 m³", value: "22" },
//   { label: "23 m³", value: "23" },
//   { label: "24 m³", value: "24" },
//   { label: "25 m³", value: "25" },
//   { label: "26 m³", value: "26" },
//   { label: "27 m³", value: "27" },
//   { label: "28 m³", value: "28" },
//   { label: "29 m³", value: "29" },
//   { label: "30 m³", value: "30" },
//   { label: "31 m³", value: "31" },
//   { label: "32 m³", value: "32" },
//   { label: "33 m³", value: "33" },
//   { label: "34 m³", value: "34" },
//   { label: "35 m³", value: "35" },
//   { label: "36 m³", value: "36" },


// ];
// const locationTypes = [
//   { label: "Propre", value: "propre" },
//   { label: "Location", value: "location" },
// ];
// const fraisTypes = [
//   { value: "perdiem_chauffeur", label: "Perdiem Chauffeur" },
//   { value: "perdiem_aide", label: "Perdiem Aide" },
//   { value: "credit", label: "Crédit" },
//   { value: "parking", label: "Parking" },
//   { value: "contravention", label: "Contravention" },
//   { value: "divers", label: "Divers" },
//   { value: "chargement", label: "Chargement" },
//   { value: "dechargement", label: "Déchargement" },
//   { value: "arrimage", label: "Arrimage" },
// ];

// const Devis = () => {
//   const [searchText, setSearchText] = useState("");
//   const [listeDevis, setListeDevis] = useState([]);
//   const [filteredDevis, setFilteredDevis] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedDevis, setSelectedDevis] = useState([]);
//   const [modalVisible, setModalVisible] = useState(false);
//   const [modalBennevisible, setModalBennevisible] = useState(false);
//   const [listeRegion, setlisteRegion] = useState([]);
//   const [listeUsers, setlisteUsers] = useState([]);
//   const [validationModalVisible, setValidationModalVisible] = useState(false);
//   const [duplicateModalVisible, setduplicateModalVisible] = useState(false);
//   const [listeClient, setListeClients] = useState([]);
//   const [validationStatus, setValidationStatus] = useState("valide_direction"); // valeur par défaut
//   const [devisToValidate, setDevisToValidate] = useState(null);
//   const [showToast, setshowToast] = useState(false);
//   const [notif, setnotif] = useState({
//     message: null,
//     info: null,
//   });
//   const [dateRange, setDateRange] = useState([]);
//   const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
//   const [tableFilters, setTableFilters] = useState({});
//   const [selectedRowKeys, setSelectedRowKeys] = useState([]); // pour stocker les IDs
//   const [selectedRows, setSelectedRows] = useState([]); // pour stocker les objets devis
//   const rowSelection = {
//     selectedRowKeys,
//     onChange: (keys, rows) => {
//       setSelectedRowKeys(keys);
//       setSelectedRows(rows);
//     },
//     selections: [
//       Table.SELECTION_ALL,
//       Table.SELECTION_INVERT,
//       Table.SELECTION_NONE,
//     ],
//   };
//   const [showModalFusion, setshowModalFusion] = useState(false);
//   const [optionFusion, setOptionFusion] = useState({
//     tva: 0,
//     acompte: 0,
//     paiement: "cheque",
//   });
//   const [currentStep, setCurrentStep] = useState(0);
//   const [temp, settemp] = useState({})
//   const [listAgence, setListeAgence] = useState([])
//   const [currentBennes, setcurrentBennes] = useState([])
//   const [currentFrais, setCurrentFrais] = useState([])
//   const [updateBenne, setUpdateBenne] = useState(false);

//   useEffect(() => {
//     fetchListeAgence()
//     fetchUsers();
//     fetchListeClients();
//     fetchRegions();
//     fetchDevis();
//   }, []);

//   const fetchListeAgence = async () => {
//     const res = await get_all_agences();
//     if (res.status === "success") {
//       setListeAgence(res.data);
//     }
//   };

//   const fetchDevis = async (range = []) => {
//     try {
//       setLoading(true);
//       let start, end;
//       if (range.length === 2) {
//         start = moment(range[0]).format("YYYY-MM-DD HH:MM:SS");
//         end = moment(range[1]).format("YYYY-MM-DD");
//       } else {
//         end = moment().format("YYYY-MM-DD");
//         start = moment().subtract(3, "months").format("YYYY-MM-DD HH:MM:SS");
//       }
//       const res = await getall_devis({ start, end });
//       if (res.data && Array.isArray(res.data)) {
//         setListeDevis(res.data);
//         setFilteredDevis(res.data);
//       } else {
//         message.warning("Aucune donnée trouvée.");
//       }
//     } catch (error) {
//       message.error("Erreur lors du chargement des devis");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchRegions = async () => {
//     const res = await get_ListeRegion();
//     setlisteRegion(res.data || []);
//   };

//   const fetchUsers = async () => {
//     const res = await get_all_users();
//     setlisteUsers(res.data || []);
//   };

//   const fetchListeClients = async () => {
//     const res = await get_ListeClients();
//     setListeClients(res.data);
//   };

//   const handleSearch = (e) => {
//     const value = e.target.value.toLowerCase();
//     setSearchText(value);
//     const filtered = listeDevis.filter((item) => {
//       const ref = item.ref?.toLowerCase?.() || "";
//       const desc = item.description?.toLowerCase?.() || "";
//       const client = item.client_nom?.toLowerCase?.() || "";
//       return (
//         ref.includes(value) || desc.includes(value) || client.includes(value)
//       );
//     });
//     setFilteredDevis(filtered);
//   };

//   const closeModal = () => {
//     setSelectedDevis([]);
//     setModalVisible(false);
//   };

//   const closeModalBenne = () => {
//     setSelectedDevis([]);
//     setModalBennevisible(false);
//   };

//   const openValidationModal = (record) => {
//     setDevisToValidate(record);
//     setValidationStatus(record.statut_devis || "pending");
//     setValidationModalVisible(true);
//   };

//   const closeValidationModal = () => {
//     setDevisToValidate(null);
//     setValidationModalVisible(false);
//   };

//   const handleValidateDevis = async () => {
//     if (!devisToValidate) return;

//     const res = await toggle_devis(devisToValidate.id, validationStatus);
//     console.log(res);
//     if (res.status === "success") {
//       setnotif({
//         ...notif,
//         message: "Devis mise à jour avec succés",
//         info: "success",
//       });
//       setshowToast(true);
//       setTimeout(() => {
//         window.location.reload();
//       }, 1500);
//     } else {
//       message.warning("Erreur lors de la modification du devis !!!");
//       setnotif({
//         ...notif,
//         message: "Erreur lors de la modification du devis !!!",
//         info: "error",
//       });
//       setshowToast(true);
//       setTimeout(() => {
//         setshowToast(false);
//       }, 1500);
//     }
//   };

//   const handleDownload = async (record) => {
//     try {
//       await downloadDevis(record.id);
//     } catch (error) {
//       if (error.code === "ERR_NETWORK") {
//         setnotif({
//           ...notif,
//           message: "Devis mise à jour avec succés",
//           info: "success",
//         });
//         setshowToast(true);
//         setTimeout(() => {
//           window.location.reload();
//         }, 1500);
//       } else {
//         throw error;
//       }
//     }
//   };

//   const fmt = (num, suffix = "") => {
//     const n = Number(num);
//     if (!isFinite(n)) return "-";
//     return `${n.toLocaleString("fr-FR")} ${suffix}`.trim();
//   };

//   const handlegetdevisbyid = async (record) => {
//     const res = await get_devis(record.id);
//     console.log(res.data)
//     setSelectedDevis(res.data);
//     if (record.service === "BENNE") {
//       if (record.statut_devis === "attente_masoandro") {
//         setUpdateBenne(true)
//       }
//       const current = res.data[0]?.bennes;
//       let parsedBennes = [];
//       try {
//         parsedBennes = current ? JSON.parse(current) : [];
//       } catch (error) {
//         console.error("Erreur parsing bennes:", error);
//         parsedBennes = [];
//       }
//       const frais = []
//       const perdiem_chauffeur = res.data[0]?.perdiem_chauffeur;
//       const perdiem_chauffeur_mulit = res.data[0]?.perdiem_chauffeur_multi;
//       const perdiem_aide = res.data[0]?.perdiem_aide;
//       const perdiem_aide_mulit = res.data[0]?.perdiem_aide_multi;
//       const chargement = res.data[0]?.chargement;
//       const chargement_multi = res.data[0]?.chargement_multi;
//       const dechargement = res.data[0]?.dechargement;
//       const dechargement_multi = res.data[0]?.dechargement_multi;
//       const contravention = res.data[0]?.contravention;
//       const contravention_multi = res.data[0]?.contravention_multi;
//       const parking = res.data[0]?.parking;
//       const parking_multi = res.data[0]?.parking_multi;
//       const divers = res.data[0]?.divers;
//       const divers_multi = res.data[0]?.divers_multi;
//       const arrimage = res.data[0]?.arrimage;
//       const arrimage_multi = res.data[0]?.arrimage_multi;
//       const credit = res.data[0]?.credit;
//       const credit_multi = res.data[0]?.credit_multi;

//       if (perdiem_chauffeur !== "0") {
//         frais.push({
//           type: "perdiem_chauffeur",
//           montant: perdiem_chauffeur,
//           multiplicateur: perdiem_chauffeur_mulit,
//           total: Number(perdiem_chauffeur) * Number(perdiem_chauffeur_mulit),
//         })
//       }
//       if (perdiem_aide !== "0") {
//         frais.push({
//           type: "perdiem_aide",
//           montant: perdiem_aide,
//           multiplicateur: perdiem_aide_mulit,
//           total: Number(perdiem_aide) * Number(perdiem_aide_mulit),
//         })
//       }
//       if (chargement !== "0") {
//         frais.push({
//           type: "chargement",
//           montant: chargement,
//           multiplicateur: chargement_multi,
//           total: Number(chargement) * Number(chargement_multi),
//         })
//       }
//       if (dechargement !== "0") {
//         frais.push({
//           type: "dechargement",
//           montant: dechargement,
//           multiplicateur: dechargement_multi,
//           total: Number(dechargement) * Number(dechargement_multi),
//         })
//       }
//       if (contravention !== "0") {
//         frais.push({
//           type: "contravention",
//           montant: contravention,
//           multiplicateur: contravention_multi,
//           total: Number(contravention) * Number(contravention_multi),
//         })
//       }
//       if (parking !== "0") {
//         frais.push({
//           type: "parking",
//           montant: parking,
//           multiplicateur: parking_multi,
//           total: Number(parking) * Number(parking_multi),
//         })
//       }
//       if (divers !== "0") {
//         frais.push({
//           type: "divers",
//           montant: divers,
//           multiplicateur: divers_multi,
//           total: Number(divers) * Number(divers_multi),
//         })
//       }
//       if (arrimage !== "0") {
//         frais.push({
//           type: "arrimage",
//           montant: arrimage,
//           multiplicateur: arrimage_multi,
//           total: Number(arrimage) * Number(arrimage_multi),
//         })
//       }
//       if (credit !== "0") {
//         frais.push({
//           type: "credit",
//           montant: credit,
//           multiplicateur: credit_multi,
//           total: Number(credit) * Number(credit_multi),
//         })
//       }
//       setCurrentFrais(frais);
//       setcurrentBennes(parsedBennes);
//       setModalBennevisible(true);
//     } else {
//       setModalVisible(true);
//     }
//   };


//   const columns = [
//     {
//       title: "ID",
//       dataIndex: "id",
//       key: "id",
//     },
//     {
//       title: "Date création",
//       dataIndex: "create_at",
//       key: "create_at",
//       render: (text) =>
//         new Date(text).toISOString().slice(0, 19).replace("T", " "),
//     },
//     {
//       title: "Service",
//       dataIndex: "service",
//       key: "service",
//       filters: Array.from(
//         new Set(listeDevis?.map(item => item.service).filter(Boolean))
//       ).map(service => ({
//         text: service,
//         value: service,
//       })),
//       onFilter: (value, record) => record.service === value,

//       render: (service) => {
//         let color = "blue";
//         if (service === "TRANSPORT") color = "magenta";
//         if (service === "BENNE") color = "PURPLE";

//         return <Tag color={color}>{service}</Tag>;
//       },
//     },
//     {
//       title: "Départ",
//       dataIndex: "region_depart",
//       key: "region_depart",
//       filters: listeRegion.map((r) => ({
//         text: r.nom,
//         value: r.id,
//       })),
//       onFilter: (value, record) => record.region_depart === value,
//       render: (rd) => {
//         const reg = listeRegion.find((u) => u.id === rd);
//         return <Tag color="gold">{reg ? reg.nom : "Inconnu"}</Tag>;
//       },
//     },
//     {
//       title: "Destination",
//       dataIndex: "region_arrive",
//       key: "region_arrive",
//       filters: listeRegion.map((r) => ({
//         text: r.nom,
//         value: r.id,
//       })),
//       onFilter: (value, record) => record.region_arrive === value,
//       render: (rd) => {
//         const reg = listeRegion.find((u) => u.id === rd);
//         return <Tag color="green">{reg ? reg.nom : "Inconnu"}</Tag>;
//       },
//     },
//     {
//       title: "Référence",
//       dataIndex: "ref",
//       key: "ref",
//       filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
//         <div style={{ padding: 8 }}>
//           <Input
//             placeholder="Rechercher..."
//             value={selectedKeys[0]}
//             onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
//             onPressEnter={() => confirm()}
//             style={{ marginBottom: 8, display: "block" }}
//           />
//           <Space>
//             <Button type="primary" onClick={() => confirm()} size="small">
//               Rechercher
//             </Button>
//             <Button onClick={() => clearFilters()} size="small">
//               Réinitialiser
//             </Button>
//           </Space>
//         </div>
//       ),
//       onFilter: (value, record) =>
//         record.ref?.toLowerCase().includes(value.toLowerCase()),

//       filterIcon: (filtered) => (
//         <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
//       ),
//     },
//     {
//       title: "Client",
//       dataIndex: "client_nom",
//       key: "client_nom",
//       filters: Array.from(
//         new Set(listeDevis.map((item) => item.client_nom))
//       ).map((name) => ({
//         text: name,
//         value: name,
//       })),
//       onFilter: (value, record) => record.client_nom === value,
//     },
//     {
//       title: "Utilisateur",
//       dataIndex: "user_create_id",
//       key: "user_create_id",
//       align: "center",

//       // 🔹 Filtre par agence
//       filters: listAgence.map(a => ({
//         text: a.nom,
//         value: `agence_${a.id}`, // on marque que c’est un filtre agence
//       })),

//       // 🔹 OnFilter pour gérer filtre combiné
//       onFilter: (value, record) => {
//         const user = listeUsers.find(u => u.id === record.user_create_id);
//         if (!user) return false;

//         // Filtre par agence
//         if (value.startsWith("agence_")) {
//           const agenceId = Number(value.split("_")[1]);
//           return user.agence_id === agenceId;
//         }

//         // Filtre par utilisateur
//         return user.id === value;
//       },

//       // 🔹 Affichage + filtres utilisateurs (dynamique selon l’agence sélectionnée)
//       render: (_, record) => {
//         const user = listeUsers.find(u => u.id === record.user_create_id);
//         if (!user) return "—";

//         const agence = listAgence.find(a => a.id === user.agence_id);
//         const fullName = `${user.prenom} ${user.nom}`;

//         // Couleur du tag selon fonction
//         const fonctionTagColor = user.fonction_id === 1 ? "blue" : "green";

//         return (
//           <Space direction="vertical" size={2}>
//             <Tag color={fonctionTagColor}>{fullName}</Tag>
//             {agence && <Tag color="orange">{agence.nom}</Tag>}
//           </Space>
//         );
//       },
//     },
//     {
//       title: "Status",
//       dataIndex: "statut_devis",
//       key: "statut_devis",
//       filters: [
//         { text: "Validé par Masoandro", value: "valide_direction" },
//         { text: "Refusé par Masoandro", value: "invalide_direction" },
//         {
//           text: "En attente de validation Masoandro",
//           value: "attente_masoandro",
//         },
//         { text: "En attente de validation Client", value: "attente_client" },
//         { text: "Validé par le client", value: "valide_client" },
//         { text: "Refusé par le client", value: "invalide_client" },
//       ],
//       onFilter: (value, record) => record.statut_devis === value,
//       render: (status) => {
//         let color = "default";
//         let text = status;

//         switch (status) {
//           case "valide_direction":
//             color = "green"; // validé Masoandro → vert
//             text = "Validé par Masoandro";
//             break;
//           case "invalide_direction":
//             color = "red"; // refusé Masoandro → rouge
//             text = "Refusé par Masoandro";
//             break;
//           case "attente_masoandro":
//             color = "orange"; // en attente Masoandro → orange
//             text = "En attente de validation Masoandro";
//             break;
//           case "attente_client":
//             color = "blue"; // en attente client → bleu
//             text = "En attente de validation Client";
//             break;
//           case "valide_client":
//             color = "cyan"; // validé client → cyan clair
//             text = "Validé par le client";
//             break;
//           case "invalide_client":
//             color = "magenta"; // refusé client → magenta / rose
//             text = "Refusé par le client";
//             break;
//           default:
//             color = "default";
//             text = "Inconnu";
//         }

//         return <Tag color={color}>{text}</Tag>;
//       },
//     },
//     {
//       title: "Description",
//       dataIndex: "description",
//       key: "description",
//     },
//     {
//       title: "Action",
//       key: "action",
//       render: (_, record) => (
//         <Space size="middle">
//           {
//             hasPermission(getPermissionsFromToken(), "DEVIS_VIEW") && <Button
//               className="btn btn-info btn-sm"
//               onClick={() => handlegetdevisbyid(record)}
//               title="Voir le devis"
//             >
//               <EyeOutlined />
//             </Button>
//           }

//           {
//             record.service !== 'BENNE' && hasPermission(getPermissionsFromToken(), "DEVIS_DUPLICATE") && <Button
//               className="btn btn-warning btn-sm"
//               disabled={record.isparent === 1} // 👈 ici !
//               onClick={() => {
//                 setSelectedDevis([record]);
//                 setduplicateModalVisible(true);
//               }}
//               title={
//                 record.isparent === 1
//                   ? "Duplication impossible pour un parent"
//                   : "Dupliquer le devis"
//               }
//             >
//               <CopyOutlined />
//             </Button>
//           }

//           {
//             hasPermission(getPermissionsFromToken(), "DEVIS_CHANGE_STATUS") && <Button
//               className="btn btn-success btn-sm"
//               onClick={() => openValidationModal(record)}
//               title="Valider le devis"
//             >
//               <CheckOutlined />
//             </Button>
//           }

//           {/* {
//             hasPermission(getPermissionsFromToken(), "DEVIS_DOWNLOAD") && <Button
//               onClick={() => handleDownload(record)}
//               className="btn btn-secondary btn-sm"
//               title="Télécharger le devis"
//             >
//               <FilePdfOutlined />
//             </Button>
//           } */}
//           {
//             hasPermission(getPermissionsFromToken(), "DEVIS_DOWNLOAD") &&
//             ["valide_direction", "valide_client"].includes(record.statut_devis) && (
//               <Button
//                 onClick={() => handleDownload(record)}
//                 className="btn btn-secondary btn-sm"
//                 title="Télécharger le devis"
//               >
//                 <FilePdfOutlined />
//               </Button>
//             )
//           }

//         </Space>
//       ),
//     },
//   ];

//   // ✅ Sections du modal enrichies
//   const sections = selectedDevis
//     ? (() => {
//       const total_brut_num = Number(selectedDevis.total_brut) || 0; // HT
//       const tva_percent = Number(selectedDevis.tva) || 0;
//       const cout_tva_num = (tva_percent * total_brut_num) / 100;
//       const total_ttc_num = total_brut_num + cout_tva_num;
//       const total_benefice_num = Number(selectedDevis.total_benefice) || 0;
//       const acompte_percent = Number(selectedDevis.acompte) || 0;
//       const cout_acompte_num = (acompte_percent * total_ttc_num) / 100;

//       return [
//         {
//           title: "Informations générales",
//           data: [
//             ["Client", selectedDevis.client_nom],
//             ["Référence", selectedDevis.ref],
//             ["Description", selectedDevis.description],
//             ["Poids (kg)", fmt(selectedDevis.poids)],
//             ["Distance (km)", fmt(selectedDevis.distance)],
//             [
//               "Créé le",
//               selectedDevis.create_at
//                 ? new Date(selectedDevis.create_at).toLocaleString()
//                 : "-",
//             ],
//             [
//               "Date départ",
//               selectedDevis.date_depart
//                 ? new Date(selectedDevis.date_depart).toLocaleString()
//                 : "-",
//             ],
//             [
//               "Date arrivée",
//               selectedDevis.date_arrive
//                 ? new Date(selectedDevis.date_arrive).toLocaleString()
//                 : "-",
//             ],
//             [
//               "Région départ",
//               listeRegion?.find((r) => r.id === selectedDevis.region_depart)
//                 ?.nom || "-",
//             ],
//             [
//               "Région arrivée",
//               listeRegion?.find((r) => r.id === selectedDevis.region_arrive)
//                 ?.nom || "-",
//             ],
//           ],
//         },
//         {
//           title: "Frais & Dépenses",
//           data: [
//             [
//               "Perdiem chauffeur",
//               fmt(
//                 Number(selectedDevis.perdiem_chauffeur) *
//                 Number(selectedDevis.perdiem_chauffeur_multi),
//                 "Ar"
//               ),
//             ],
//             [
//               "Perdiem aide",
//               fmt(
//                 Number(selectedDevis.perdiem_aide) *
//                 Number(selectedDevis.perdiem_aide_multi),
//                 "Ar"
//               ),
//             ],
//             [
//               "Crédit",
//               fmt(
//                 Number(selectedDevis.credit) *
//                 Number(selectedDevis.credit_multi),
//                 "Ar"
//               ),
//             ],
//             [
//               "Parking",
//               fmt(
//                 Number(selectedDevis.parking) *
//                 Number(selectedDevis.parking_multi),
//                 "Ar"
//               ),
//             ],
//             [
//               "Contravention",
//               fmt(
//                 Number(selectedDevis.contravention) *
//                 Number(selectedDevis.contravention_multi),
//                 "Ar"
//               ),
//             ],
//             [
//               "Chargement",
//               fmt(
//                 Number(selectedDevis.chargement) *
//                 Number(selectedDevis.chargement_multi),
//                 "Ar"
//               ),
//             ],
//             [
//               "Déchargement",
//               fmt(
//                 Number(selectedDevis.dechargement) *
//                 Number(selectedDevis.dechargement_multi),
//                 "Ar"
//               ),
//             ],
//             [
//               "Arrimage",
//               fmt(
//                 Number(selectedDevis.arrimage) *
//                 Number(selectedDevis.arrimage_multi),
//                 "Ar"
//               ),
//             ],
//             [
//               "Divers",
//               fmt(
//                 Number(selectedDevis.divers) *
//                 Number(selectedDevis.divers_multi),
//                 "Ar"
//               ),
//             ],
//           ],
//         },
//         {
//           title: "Totaux & Finances",
//           data: [
//             ["Cotation", fmt(selectedDevis.cotation, "Ar")],
//             ["TVA (%)", fmt(tva_percent)],
//             ["Coût TVA", fmt(cout_tva_num, "Ar")],
//             ["Total net (HT)", fmt(total_brut_num, "Ar")],
//             ["Total brut (TTC)", fmt(total_ttc_num, "Ar")],
//             ["Bénéfice", fmt(total_benefice_num, "Ar")],
//             ["Acompte (%)", fmt(acompte_percent)],
//             ["Coût Acompte", fmt(cout_acompte_num, "Ar")],
//           ],
//         },
//       ];
//     })()
//     : [];

//   const handleDateChange = (dates) => {
//     setDateRange(dates);
//   };

//   const handleTableChange = (pag, filters, sorter) => {
//     setPagination(pag);
//     setTableFilters(filters);
//   };

//   const handleExport = async () => {
//     const params = new URLSearchParams();
//     if (dateRange.length === 2) {
//       params.append(
//         "start",
//         moment(dateRange[0]).format("YYYY-MM-DD HH:mm:ss")
//       );
//       params.append("end", moment(dateRange[1]).format("YYYY-MM-DD HH:mm:ss"));
//     } else {
//       // Si pas de date sélectionnée, 3 derniers mois par défaut
//       params.append("end", moment().format("YYYY-MM-DD HH:mm:ss"));
//       params.append(
//         "start",
//         moment().subtract(3, "months").format("YYYY-MM-DD HH:mm:ss")
//       );
//     }
//     // Autres filtres du tableau
//     if (tableFilters.region_depart?.length)
//       params.append("region_depart", tableFilters.region_depart.join(","));
//     if (tableFilters.region_arrive?.length)
//       params.append("region_arrive", tableFilters.region_arrive.join(","));
//     if (tableFilters.client_nom?.length)
//       params.append("client", tableFilters.client_nom.join(","));
//     if (tableFilters.user_create_id?.length)
//       params.append("commercial", tableFilters.user_create_id.join(","));
//     if (tableFilters.statut_devis?.length)
//       params.append("statut", tableFilters.statut_devis.join(","));

//     const res = await export_devis(params.toString());
//   };

//   const handleMergedExport = async () => {
//     const listId = selectedRows.map((i) => i.id);
//     const res = await merge_devis(listId, optionFusion);
//     if (res.status === "success") {
//       setnotif({
//         ...notif,
//         message: "Devis dupliqué avec succés",
//         info: "success", 
//       });
//       setshowToast(true);
//       setTimeout(() => {
//         window.location.reload();
//       }, 1500);
//     } else {
//       setnotif({
//         ...notif,
//         message: "Devis non dupliqué !!!",
//         info: "error",
//       });
//       setshowToast(true);
//       setTimeout(() => {
//         setshowToast(false);
//       }, 1500);
//     }

//   };

//   const handleDuplicate = async () => {
//     const res = await duplicate_devis(selectedDevis[0].id);
//     console.log(res);
//     if (res.status === "success") {
//       setnotif({
//         ...notif,
//         message: "Devis dupliqué avec succés",
//         info: "success",
//       });
//       setshowToast(true);
//       setTimeout(() => {
//         window.location.reload();
//       }, 1500);
//     } else {
//       setnotif({
//         ...notif,
//         message: "Devis non dupliqué !!!",
//         info: "error",
//       });
//       setshowToast(true);
//       setTimeout(() => {
//         setshowToast(false);
//       }, 1500);
//     }
//   };

//   const handleUpdate = async (devis) => {
//     console.log("Mise à jour du devis :", devis);
//     message.success(`Devis ${devis.ref} mis à jour avec succès`);
//     console.log(devis);
//     const res = await update_devis(devis);
//     console.log(res.status);
//     if (res.status === "success") {
//       setnotif({
//         ...notif,
//         message: "Devis mise à jour avec succés",
//         info: "success",
//       });
//       setshowToast(true);
//       setTimeout(() => {
//         window.location.reload();
//       }, 1500);
//     } else {
//       setnotif({
//         ...notif,
//         message: "Error mise à jour !!!!",
//         info: "error",
//       });
//       setshowToast(true);
//       setTimeout(() => {
//         window.location.reload();
//       }, 1500);
//     }
//   };

//   const steps = [
//     "Informations générales",
//     "Frais & Dépenses",
//     "Résumé & Modification",
//   ];

//   const handleChange = (index, key, value) => {
//     const newList = [...selectedDevis];
//     const devis = { ...newList[index], [key]: value };

//     // auto calcul des coefficent
//     const coef_aller =
//       devis.status_aller === 1
//         ? devis.coefficient_charge
//         : devis.coefficient_vide;

//     const coef_retour =
//       devis.status_retour === 1
//         ? devis.coefficient_charge
//         : devis.coefficient_vide;
//     const carburant_aller = devis.distance * coef_aller;
//     const carburant_retour = devis.distance * coef_retour;
//     const total_carburant = carburant_aller + carburant_retour;
//     const total_gasoil = Number(total_carburant * devis.prix_go).toFixed(2);
//     const total_brute = devis.cotation * devis.poids;
//     // Calcul auto du total dépense
//     const total_frais =
//       (devis.perdiem_chauffeur || 0) * (devis.perdiem_chauffeur_multi || 0) +
//       (devis.perdiem_aide || 0) * (devis.perdiem_aide_multi || 0) +
//       (devis.credit || 0) * (devis.credit_multi || 0) +
//       (devis.parking || 0) * (devis.parking_multi || 0) +
//       (devis.contravention || 0) * (devis.contravention_multi || 0) +
//       (devis.divers || 0) * (devis.divers_multi || 0) +
//       (devis.chargement || 0) * (devis.chargement_multi || 0) +
//       (devis.dechargement || 0) * (devis.dechargement_multi || 0) +
//       (devis.arrimage || 0) * (devis.arrimage_multi || 0);
//     const total_benefice = total_brute - total_gasoil - total_frais;

//     devis.total_brut = total_brute;
//     devis.total_depense = total_frais;
//     devis.total_benefice = total_benefice;
//     devis.total_go = total_gasoil;
//     devis.total_carburant = total_carburant;
//     devis.carburant_aller = carburant_aller;
//     devis.carburant_retour = carburant_retour;

//     newList[index] = devis;
//     setSelectedDevis(newList);
//   };

//   const addFraisLine = () => {
//     setCurrentFrais((prev) => [
//       ...prev,
//       {
//         type: null,
//         montant: 0,
//         multiplicateur: 1,
//         total: 0,
//       },
//     ]);
//   };

//   const removeFraisLine = (index) => {
//     setCurrentFrais((prev) =>
//       prev.filter((_, i) => i !== index)
//     );
//   };

//   const updateFraisLine = (index, field, value) => {
//     setCurrentFrais((prev) => {
//       const newFrais = [...prev];

//       newFrais[index] = {
//         ...newFrais[index],
//         [field]: value,
//       };

//       // recalcul automatique
//       const m = Number(newFrais[index].montant) || 0;
//       const mult = Number(newFrais[index].multiplicateur) || 0;
//       newFrais[index].total = m * mult;

//       return newFrais;
//     });
//   };

//   const handleDevisBenneChange = (field, value, index = 0) => {
//     setSelectedDevis((prev) => {
//       if (!prev || !prev.length) return prev;
//       const updated = [...prev];
//       updated[index] = {
//         ...updated[index],
//         [field]: value,
//       };

//       return updated;
//     });
//   };

//   const removeBenne = (index) => {
//     const newBennes = currentBennes.filter((_, i) => i !== index);
//     setcurrentBennes(newBennes);
//   };

//   const addBenne = () => {
//     setcurrentBennes([
//       ...currentBennes,
//       {
//         description: "",
//         date_location: moment(),
//         volume: "20",
//         situation: "propre",
//         quantite: 0,
//         prix_unitaire: 0,
//         total: 0
//       }
//     ]);
//   };

//   const updateBenneField = (index, field, value) => {
//     const newBennes = [...currentBennes];
//     newBennes[index][field] = value;
//     const qte = newBennes[index].quantite || 0;
//     const pu = newBennes[index].prix_unitaire || 0;
//     newBennes[index].total = qte * pu;
//     setcurrentBennes(newBennes);
//   };

//   const handleUpdateBennes = async () => {
//     const baseDevis = selectedDevis?.[0];

//     if (!baseDevis) return;

//     const payload = {
//       ...baseDevis, // copie propre
//       bennes: JSON.stringify(currentBennes),
//     };

//     payload.perdiem_chauffeur = 0;
//     payload.perdiem_chauffeur_multi = 0;
//     payload.perdiem_aide = 0;
//     payload.perdiem_aide_multi = 0;
//     payload.credit = 0;
//     payload.credit_multi = 0;
//     payload.parking = 0;
//     payload.parking_multi = 0;
//     payload.contravention = 0;
//     payload.contravention_multi = 0;
//     payload.chargement = 0;
//     payload.chargement_multi = 0;
//     payload.dechargement = 0;
//     payload.dechargement_multi = 0;
//     payload.arrimage = 0;
//     payload.arrimage_multi = 0;
//     payload.divers = 0;
//     payload.divers_multi = 0;
//     console.log(payload.chargement, payload.chargement_multi);

//     //   const fraisTypes = [
//     //   { value: "perdiem_chauffeur", label: "Perdiem Chauffeur" },
//     //   { value: "perdiem_aide", label: "Perdiem Aide" },
//     //   { value: "credit", label: "Crédit" },
//     //   { value: "parking", label: "Parking" },
//     //   { value: "contravention", label: "Contravention" },
//     //   { value: "divers", label: "Divers" },
//     //   { value: "chargement", label: "Chargement" },
//     //   { value: "dechargement", label: "Déchargement" },
//     //   { value: "arrimage", label: "Arrimage" },
//     // ];


//     currentFrais.forEach((elem) => {
//       console.log(elem);
//       if (elem.type === "perdiem_chauffeur") {
//         payload.perdiem_chauffeur = elem.montant;
//         payload.perdiem_chauffeur_multi = elem.multiplicateur;
//       }

//       if (elem.type === "perdiem_aide") {
//         payload.perdiem_aide = elem.montant;
//         payload.perdiem_aide_multi = elem.multiplicateur;
//       }

//       if (elem.type === "credit") {
//         payload.credit = elem.montant;
//         payload.credit_multi = elem.multiplicateur;
//       }

//       if (elem.type === "parking") {
//         payload.parking = elem.montant;
//         payload.parking_multi = elem.multiplicateur;
//       }

//       if (elem.type === "contravention") {
//         payload.contravention = elem.montant;
//         payload.contravention_multi = elem.multiplicateur;
//       }

//       if (elem.type === "divers") {
//         payload.divers = elem.montant;
//         payload.divers_multi = elem.multiplicateur;
//       }

//       if (elem.type === "dechargement") {
//         payload.dechargement = elem.montant;
//         payload.dechargement_multi = elem.multiplicateur;
//       }

//       if (elem.type === "chargement") {
//         payload.chargement = elem.montant;
//         payload.chargement_multi = elem.multiplicateur;
//       }

//       if (elem.type === "arrimage") {
//         payload.arrimage = elem.montant;
//         payload.arrimage_multi = elem.multiplicateur;
//       }

//     });
//     console.log(payload.chargement, payload.chargement_multi);
//     const res = await update_devis(payload);
//     if (res.status === "success") {
//       setnotif({
//         ...notif,
//         message: "Devis mise à jour avec succés",
//         info: "success",
//       });
//       setSelectedDevis([])
//       setshowToast(true);
//       setTimeout(() => {
//         window.location.reload();
//       }, 1500);
//     } else {
//       setnotif({
//         ...notif,
//         message: "Error mise à jour !!!!",
//         info: "error",
//       });
//       setSelectedDevis([])
//       setshowToast(true);
//       setTimeout(() => {
//         window.location.reload();
//       }, 1500);
//     }
//   };

//   return (
//     <div className="p-0">
//       {/* HEADER */}
//       <div className="flex justify-between items-center mb-4">
//         <Space style={{ width: "85%" }}>
//           <Input
//             placeholder="🔍 Rechercher..."
//             value={searchText}
//             onChange={handleSearch}
//             prefix={<SearchOutlined />}
//             style={{ width: 250 }}
//           />
//           <RangePicker
//             showTime={{
//               defaultValue: [
//                 moment("00:00:00", "HH:mm:ss"),
//                 moment("00:00:00", "HH:mm:ss"),
//               ],
//             }}
//             onChange={handleDateChange} size="small"
//           />
//           <Button
//             icon={<ReloadOutlined />}
//             onClick={() => fetchDevis(dateRange)}
//             loading={loading}
//             style={{
//               backgroundColor: "#0d6efd",
//               borderColor: "#0d6efd",
//               color: "#fff",
//             }}
//           >
//             Recharger
//           </Button>

//           {
//             hasPermission(getPermissionsFromToken(), "DEVIS_FUSIONNER") && <Button
//               type="primary"
//               onClick={() => {
//                 setshowModalFusion(true);
//               }}
//               disabled={selectedRows.length < 2} // désactivé si rien n'est sélectionné
//               style={{
//                 backgroundColor: "#0dcaf0", // couleur info Bootstrap
//                 borderColor: "#0dcaf0",
//                 color: "#fff",
//               }}
//             >
//               Fusionner
//             </Button>
//           }

//         </Space>
//         {
//           hasPermission(getPermissionsFromToken(), "DEVIS_EXPORT") && <Button
//             icon={<PlusOutlined />}
//             style={{
//               backgroundColor: "#198754",
//               borderColor: "#198754",
//               color: "#fff",
//             }}
//             onClick={handleExport}
//           >
//             Exporter
//           </Button>
//         }
//       </div>
//       <Spin spinning={loading}>
//         <div style={{
//           height: '70vh',
//           overflowY: "auto"
//         }}>
//           <Table
//             rowKey="id"
//             columns={columns}
//             dataSource={filteredDevis}
//             loading={loading}
//             pagination={{
//               pageSize: 8,
//               position: ["bottomCenter"],
//               className: "custom-pagination",
//               style: {
//                 display: "flex",
//                 justifyContent: "center",
//                 marginTop: 12,
//               },
//               itemRender: (page, type, originalElement) => {
//                 if (type === "page") {
//                   return (
//                     <div
//                       style={{
//                         borderRadius: "50%",
//                         minWidth: 32,
//                         height: 32,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         border: "1px solid #d9d9d9",
//                       }}
//                     >
//                       {page}
//                     </div>
//                   );
//                 }
//                 return originalElement;
//               },
//             }}
//             onChange={handleTableChange}
//             rowSelection={rowSelection} // ✅ ajouté ici
//           />
//         </div>
//       </Spin>

//       <Modal
//         title={`Valider le devis ${devisToValidate?.ref || ""}`}
//         open={validationModalVisible}
//         onCancel={closeValidationModal}
//         footer={[
//           <Button key="cancel" onClick={closeValidationModal}>
//             Annuler
//           </Button>,
//           <Button key="confirm" type="primary" onClick={handleValidateDevis}>
//             Confirmer
//           </Button>,
//         ]}
//       >
//         <Row>
//           <Col span={6}>
//             <p>Choisir le statut :</p>
//           </Col>
//           <Col span={18} style={{ padding: 10 }}>
//             <Select
//               size="large"
//               value={validationStatus}
//               onChange={(val) => setValidationStatus(val)}
//               style={{ width: "100%" }}
//             >
//               {
//                 hasPermission(getPermissionsFromToken(), "VALIDATE_DEVIS") && <Option value="valide_direction">Validé par Masoandro</Option>
//               }

//               {
//                 hasPermission(getPermissionsFromToken(), "VALIDATE_DEVIS") && <Option value="invalide_direction">Invalidé par Masoandro</Option>
//               }
//               <Option value="attente_masoandro">
//                 En attente de validation Masoandro
//               </Option>
//               <Option value="attente_client">
//                 En attente de validation Client
//               </Option>
//               <Option value="valide_client">Validé par le Client</Option>
//               <Option value="invalide_client">Invalidé par le Client</Option>
//             </Select>
//           </Col>
//         </Row>
//       </Modal>
//       {/* MODAL VALIDATION */}
//       <Modal
//         title={"Fusion des devis"}
//         open={showModalFusion}
//         onCancel={() => {
//           setSelectedRows([]);
//           setshowModalFusion(false);
//         }}
//         footer={[
//           <Button
//             key="cancel"
//             onClick={() => {
//               setSelectedRows([]);
//               setshowModalFusion(false);
//             }}
//           >
//             Annuler
//           </Button>,
//           <Button key="confirm" type="primary" onClick={handleMergedExport}>
//             Confirmer
//           </Button>,
//         ]}
//       >
//         <Row>
//           <Col span={6}>
//             <p>TVA</p>
//           </Col>
//           <Col span={18} style={{ padding: 10 }}>
//             <InputNumber
//               size="large"
//               min={0}
//               max={100}
//               style={{ width: "100%" }}
//               value={optionFusion.tva || 0}
//               onChange={(value) => {
//                 setOptionFusion({
//                   ...optionFusion,
//                   tva: value,
//                 });
//               }}
//             />
//           </Col>
//         </Row>
//         <Row>
//           <Col span={6}>
//             <p>Acompte</p>
//           </Col>
//           <Col span={18} style={{ padding: 10 }}>
//             <InputNumber
//               size="large"
//               min={0}
//               max={100}
//               style={{ width: "100%" }}
//               value={optionFusion.acompte || 0}
//               onChange={(value) => {
//                 setOptionFusion({
//                   ...optionFusion,
//                   acompte: value,
//                 });
//               }}
//             />
//           </Col>
//         </Row>
//         <Row>
//           <Col span={6}>
//             <p>Paiement</p>
//           </Col>
//           <Col span={18} style={{ padding: 10 }}>
//             <Select
//               size="large"
//               style={{
//                 width: "100%",
//                 textAlign: "center",
//                 fontWeight: 600,
//               }}
//               value={optionFusion.paiement}
//               onChange={(value) =>
//                 setOptionFusion((prev) => ({
//                   ...prev,
//                   paiement: value,
//                 }))
//               }
//             >
//               <Option key="cheque" value="cheque"></Option>
//               <Option key="mobile_money" value="Mobile Money"></Option>
//               <Option key="espece" value="Espèces"></Option>
//               <Option key="virement" value="Virement bancaire"></Option>
//             </Select>
//           </Col>
//         </Row>
//       </Modal>
//       {/* MODAL VALIDATION */}
//       <Modal
//         title={`Dupliquer le devis ${selectedDevis?.ref || ""}`}
//         open={duplicateModalVisible}
//         onCancel={() => {
//           setduplicateModalVisible(false);
//           setSelectedDevis([]);
//           settemp({})
//         }}
//         footer={[
//           <Button
//             key="cancel"
//             onClick={() => {
//               setduplicateModalVisible(false);
//               setSelectedDevis([]);
//               settemp({})
//             }}
//           >
//             Annuler
//           </Button>,
//           <Button key="confirm" type="primary" onClick={handleDuplicate}>
//             Confirmer
//           </Button>,
//         ]}
//       >
//         <div style={{ textAlign: "center", width: "100%" }}>
//           Voulez vous vraiement dupliquer ce devis ?
//         </div>
//       </Modal>

//       <Modal
//         title={`📋 Détails du devis `}
//         open={modalVisible}
//         onCancel={closeModal}
//         footer={[
//           <Button key="close" onClick={closeModal}>
//             Fermer
//           </Button>,
//         ]}
//         width="70%"
//         style={{ top: 0 }}
//       >
//         <div
//           style={{
//             width: "100%",
//             height: "77vh",
//             paddingRight: "10px",
//             overflowY: "auto",
//           }}
//         >
//           <Tabs
//             className="custom-tabs"
//             defaultActiveKey={selectedDevis?.[0]?.ref}
//           >
//             {selectedDevis &&
//               selectedDevis.map((devis, index) => {
//                 return (
//                   <TabPane tab={devis.ref} key={devis.ref}>
//                     <div
//                       style={{
//                         border: "1px solid rgba(252, 235, 235, 1)ff",
//                         borderRadius: 8,
//                         backgroundColor: "#fafafa",
//                         boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
//                       }}
//                     >
//                       <Steps
//                         current={currentStep}
//                         onChange={setCurrentStep}
//                         style={{ marginBottom: 20 }}
//                         size="small"
//                         items={steps.map((title) => ({ title }))}
//                       />

//                       {currentStep === 0 && (
//                         <>
//                           <Divider>Informations générales</Divider>
//                           <Row gutter={16}>
//                             <Col span={4}>
//                               <label>Client</label>
//                               <Select
//                                 size="medium"
//                                 placeholder="Clients"
//                                 style={{
//                                   width: "100%",
//                                   textAlign: "center",
//                                   fontWeight: 600,
//                                 }}
//                                 value={devis.client_id}
//                                 onChange={(e) =>
//                                   handleChange(index, "client_id", e.target.value)
//                                 }
//                                 disabled
//                               >
//                                 {listeClient.map((r) => (
//                                   <Option key={r.id} value={r.id}>
//                                     {r.nom}
//                                   </Option>
//                                 ))}
//                               </Select>
//                             </Col>
//                             <Col span={4}>
//                               <label>Contact</label>
//                               <Input
//                                 value={devis.contact_client}
//                                 onChange={(e) =>
//                                   handleChange(
//                                     index,
//                                     "contact_client",
//                                     e.target.value
//                                   )
//                                 }
//                                 disabled
//                               />
//                             </Col>
//                             <Col span={4}>
//                               <label>Téléphone</label>
//                               <Input
//                                 value={devis.telephone_client}
//                                 onChange={(e) =>
//                                   handleChange(
//                                     index,
//                                     "telephone_client",
//                                     e.target.value
//                                   )
//                                 }
//                                 disabled
//                               />
//                             </Col>
//                             <Col span={6}>
//                               <label>Region départ</label>
//                               <Select
//                                 size="medium"
//                                 placeholder="Choisir la région"
//                                 style={{ width: "100%" }}
//                                 value={devis.region_depart}
//                                 onChange={(value) =>
//                                   handleChange(index, "region_depart", value)
//                                 }
//                               >
//                                 {listeRegion.map((r) => (
//                                   <Option key={r.id} value={r.id}>
//                                     {r.nom}
//                                   </Option>
//                                 ))}
//                               </Select>
//                             </Col>
//                             <Col span={6}>
//                               <label>Region arrivé</label>
//                               <Select
//                                 size="medium"
//                                 placeholder="Choisir la région"
//                                 style={{ width: "100%" }}
//                                 value={devis.region_arrive}
//                                 onChange={(value) =>
//                                   handleChange(index, "region_arrive", value)
//                                 }
//                               >
//                                 {listeRegion.map((r) => (
//                                   <Option key={r.id} value={r.id}>
//                                     {r.nom}
//                                   </Option>
//                                 ))}
//                               </Select>
//                             </Col>
//                           </Row>
//                           <br />
//                           <Row gutter={16} style={{ marginTop: 10 }}>
//                             <Col span={4}>
//                               <label>Date départ</label>
//                               <DatePicker
//                                 size="small"
//                                 showTime
//                                 style={{ width: "100%" }}
//                                 format="YYYY-MM-DD HH:mm:ss"
//                                 value={
//                                   devis.date_depart
//                                     ? moment(devis.date_depart)
//                                     : null
//                                 }
//                                 onChange={(date) =>
//                                   handleChange(
//                                     index,
//                                     "date_depart",
//                                     date ? date.toISOString() : null
//                                   )
//                                 }
//                               />
//                             </Col>
//                             <Col span={4}>
//                               <label>Date arrivé</label>
//                               <DatePicker
//                                 size="small"
//                                 showTime
//                                 style={{ width: "100%" }}
//                                 format="YYYY-MM-DD HH:mm:ss"
//                                 value={
//                                   devis.date_arrive
//                                     ? moment(devis.date_arrive)
//                                     : null
//                                 }
//                                 onChange={(date) =>
//                                   handleChange(
//                                     index,
//                                     "date_arrive",
//                                     date ? date.toISOString() : null
//                                   )
//                                 }
//                               />
//                             </Col>
//                             <Col span={4}>
//                               <label>Distance (km)</label>
//                               <InputNumber
//                                 value={devis.distance}
//                                 onChange={(value) =>
//                                   handleChange(index, "distance", value)
//                                 }
//                                 style={{ width: "100%" }}
//                               />
//                             </Col>
//                             <Col span={6}>
//                               <label>Poids (kg)</label>
//                               <InputNumber
//                                 value={devis.poids}
//                                 onChange={(value) =>
//                                   handleChange(index, "poids", value)
//                                 }
//                                 style={{ width: "100%" }}
//                               />
//                             </Col>
//                             <Col span={6}>
//                               <label>Cotation</label>
//                               <InputNumber
//                                 value={Number((devis.cotation * devis.coefficient_distance).toFixed(2))}
//                                 onChange={(value) =>
//                                   handleChange(index, "cotation", value)
//                                 }
//                                 style={{ width: "100%" }}
//                               />
//                             </Col>
//                           </Row>
//                           <br />
//                           <Row gutter={16} style={{ marginTop: 10 }}>
//                             <Col span={4}>
//                               <label>Status aller</label>
//                               <Radio.Group
//                                 value={Number(devis.status_aller)}
//                                 onChange={(e) =>
//                                   handleChange(
//                                     index,
//                                     "status_aller",
//                                     Number(e.target.value)
//                                   )
//                                 }
//                               >
//                                 <Radio value={1}>Chargé</Radio>
//                                 <Radio value={0}>Vide</Radio>
//                               </Radio.Group>
//                             </Col>

//                             <Col span={4}>
//                               <label>Status retour</label>
//                               <Radio.Group
//                                 value={Number(devis.status_retour)}
//                                 onChange={(e) =>
//                                   handleChange(
//                                     index,
//                                     "status_retour",
//                                     Number(e.target.value)
//                                   )
//                                 }
//                               >
//                                 <Radio value={1}>Chargé</Radio>
//                                 <Radio value={0}>Vide</Radio>
//                               </Radio.Group>
//                             </Col>

//                             <Col span={4}>
//                               <label>Coefficient chargé</label>
//                               <InputNumber
//                                 value={devis.coefficient_charge}
//                                 onChange={(value) =>
//                                   handleChange(index, "coefficient_charge", value)
//                                 }
//                                 style={{ width: "100%" }}
//                               />
//                             </Col>
//                             <Col span={4}>
//                               <label>Coefficient vide</label>
//                               <InputNumber
//                                 value={devis.coefficient_vide}
//                                 onChange={(value) =>
//                                   handleChange(index, "coefficient_vide", value)
//                                 }
//                                 style={{ width: "100%" }}
//                               />
//                             </Col>
//                           </Row>
//                           <br />
//                           <Row gutter={16} style={{ marginTop: 10 }}>
//                             <Col span={4}>
//                               <label>Carburant aller</label>
//                               <InputNumber
//                                 value={devis.carburant_aller}
//                                 onChange={(value) =>
//                                   handleChange(index, "carburant_aller", value)
//                                 }
//                                 style={{ width: "100%" }}
//                                 precision={2}
//                               />
//                             </Col>
//                             <Col span={4}>
//                               <label>Carburant retour</label>
//                               <InputNumber
//                                 value={devis.carburant_retour}
//                                 onChange={(value) =>
//                                   handleChange(index, "carburant_retour", value)
//                                 }
//                                 style={{ width: "100%" }}
//                                 precision={2}
//                               />
//                             </Col>
//                             <Col span={4}>
//                               <label>Carburant total</label>
//                               <InputNumber
//                                 value={devis.total_carburant}
//                                 onChange={(value) =>
//                                   handleChange(index, "total_carburant", value)
//                                 }
//                                 style={{ width: "100%" }}
//                                 precision={2}
//                               />
//                             </Col>
//                           </Row>
//                         </>
//                       )}

//                       {currentStep === 1 && (
//                         <>
//                           <Divider>Carburant & Perdiem</Divider>
//                           <Row gutter={16} style={{ marginTop: 10 }}>
//                             <Col span={6}>
//                               <label>Perdiem chauffeur</label>
//                               <Row align="middle" gutter={8}>
//                                 <Col span={9}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     style={{ width: "100%" }}
//                                     value={devis.perdiem_chauffeur}
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                     onChange={(value) =>
//                                       handleChange(
//                                         index,
//                                         "perdiem_chauffeur",
//                                         value
//                                       )
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={4}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     style={{ width: "100%" }}
//                                     value={devis.perdiem_chauffeur_multi}
//                                     onChange={(value) =>
//                                       handleChange(
//                                         index,
//                                         "perdiem_chauffeur_multi",
//                                         value
//                                       )
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={11}>
//                                   <InputNumber
//                                     size="large"
//                                     style={{ width: "100%" }}
//                                     value={
//                                       (devis.perdiem_chauffeur || 0) *
//                                       (devis.perdiem_chauffeur_multi || 0)
//                                     }
//                                     disabled
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                   />
//                                 </Col>
//                               </Row>
//                             </Col>
//                             <Col span={6}>
//                               <label>Perdiem aide chauffeur</label>
//                               <Row align="middle" gutter={8}>
//                                 <Col span={9}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     style={{ width: "100%" }}
//                                     value={devis.perdiem_aide}
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                     onChange={(value) =>
//                                       handleChange(index, "perdiem_aide", value)
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={4}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     placeholder="N"
//                                     style={{ width: "100%" }}
//                                     value={devis.perdiem_aide_multi || 0}
//                                     onChange={(value) =>
//                                       handleChange(
//                                         index,
//                                         "perdiem_aide_multi",
//                                         value
//                                       )
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={11}>
//                                   <InputNumber
//                                     size="large"
//                                     style={{ width: "100%" }}
//                                     value={
//                                       (devis.perdiem_aide || 0) *
//                                       (devis.perdiem_aide_multi || 0)
//                                     }
//                                     disabled
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                   />
//                                 </Col>
//                               </Row>
//                             </Col>
//                             <Col span={6}>
//                               <label>Parking</label>
//                               <Row align="middle" gutter={8}>
//                                 <Col span={9}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     style={{ width: "100%" }}
//                                     value={devis.parking}
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                     onChange={(value) =>
//                                       handleChange(index, "parking", value)
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={4}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     placeholder="N"
//                                     style={{ width: "100%" }}
//                                     value={devis.parking_multi || 0}
//                                     onChange={(value) =>
//                                       handleChange(index, "parking_multi", value)
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={11}>
//                                   <InputNumber
//                                     size="large"
//                                     style={{ width: "100%" }}
//                                     value={
//                                       (devis.parking || 0) *
//                                       (devis.parking_multi || 0)
//                                     }
//                                     disabled
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                   />
//                                 </Col>
//                               </Row>
//                             </Col>
//                             <Col span={6}>
//                               <label>Credit</label>
//                               <Row align="middle" gutter={8}>
//                                 <Col span={9}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     style={{ width: "100%" }}
//                                     value={devis.credit}
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                     onChange={(value) =>
//                                       handleChange(index, "credit", value)
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={4}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     placeholder="N"
//                                     style={{ width: "100%" }}
//                                     value={devis.credit_multi || 0}
//                                     onChange={(value) =>
//                                       handleChange(index, "credit_multi", value)
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={11}>
//                                   <InputNumber
//                                     size="large"
//                                     style={{ width: "100%" }}
//                                     value={
//                                       (devis.credit || 0) *
//                                       (devis.credit_multi || 0)
//                                     }
//                                     disabled
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                   />
//                                 </Col>
//                               </Row>
//                             </Col>
//                           </Row>
//                           <br />
//                           <Row gutter={16} style={{ marginTop: 10 }}>
//                             <Col span={6}>
//                               <label>Chargement</label>
//                               <Row align="middle" gutter={8}>
//                                 <Col span={9}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     style={{ width: "100%" }}
//                                     value={devis.chargement}
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                     onChange={(value) =>
//                                       handleChange(index, "chargement", value)
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={4}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     placeholder="N"
//                                     style={{ width: "100%" }}
//                                     value={devis.chargement_multi || 0}
//                                     onChange={(value) =>
//                                       handleChange(
//                                         index,
//                                         "chargement_multi",
//                                         value
//                                       )
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={11}>
//                                   <InputNumber
//                                     size="large"
//                                     style={{ width: "100%" }}
//                                     value={
//                                       (devis.chargement || 0) *
//                                       (devis.chargement_multi || 0)
//                                     }
//                                     disabled
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                   />
//                                 </Col>
//                               </Row>
//                             </Col>
//                             <Col span={6}>
//                               <label>Déchargement</label>
//                               <Row align="middle" gutter={8}>
//                                 <Col span={9}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     style={{ width: "100%" }}
//                                     value={devis.dechargement}
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                     onChange={(value) =>
//                                       handleChange(index, "dechargement", value)
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={4}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     placeholder="N"
//                                     style={{ width: "100%" }}
//                                     value={devis.dechargement_multi || 0}
//                                     onChange={(value) =>
//                                       handleChange(
//                                         index,
//                                         "dechargement_multi",
//                                         value
//                                       )
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={11}>
//                                   <InputNumber
//                                     size="large"
//                                     style={{ width: "100%" }}
//                                     value={
//                                       (devis.dechargement || 0) *
//                                       (devis.dechargement_multi || 0)
//                                     }
//                                     disabled
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                   />
//                                 </Col>
//                               </Row>
//                             </Col>
//                             <Col span={6}>
//                               <label>Contravention</label>
//                               <Row align="middle" gutter={8}>
//                                 <Col span={9}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     style={{ width: "100%" }}
//                                     value={devis.contravention}
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                     onChange={(value) =>
//                                       handleChange(index, "contravention", value)
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={4}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     placeholder="N"
//                                     style={{ width: "100%" }}
//                                     value={devis.contravention_multi || 0}
//                                     onChange={(value) =>
//                                       handleChange(
//                                         index,
//                                         "contravention_multi",
//                                         value
//                                       )
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={11}>
//                                   <InputNumber
//                                     size="large"
//                                     style={{ width: "100%" }}
//                                     value={
//                                       (devis.contravention || 0) *
//                                       (devis.contravention_multi || 0)
//                                     }
//                                     disabled
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                   />
//                                 </Col>
//                               </Row>
//                             </Col>
//                             <Col span={6}>
//                               <label>Arrimage</label>
//                               <Row align="middle" gutter={8}>
//                                 <Col span={9}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     style={{ width: "100%" }}
//                                     value={devis.arrimage}
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                     onChange={(value) =>
//                                       handleChange(index, "arrimage", value)
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={4}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     placeholder="N"
//                                     style={{ width: "100%" }}
//                                     value={devis.arrimage_multi || 0}
//                                     onChange={(value) =>
//                                       handleChange(index, "arrimage_multi", value)
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={11}>
//                                   <InputNumber
//                                     size="large"
//                                     style={{ width: "100%" }}
//                                     value={
//                                       (devis.arrimage || 0) *
//                                       (devis.arrimage_multi || 0)
//                                     }
//                                     disabled
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                   />
//                                 </Col>
//                               </Row>
//                             </Col>
//                           </Row>
//                           <br />
//                           <Row gutter={16} style={{ marginTop: 10 }}>
//                             <Col span={6}>
//                               <label>Divers</label>
//                               <Row align="middle" gutter={8}>
//                                 <Col span={9}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     style={{ width: "100%" }}
//                                     value={devis.divers}
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                     onChange={(value) =>
//                                       handleChange(index, "divers", value)
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={4}>
//                                   <InputNumber
//                                     size="large"
//                                     min={0}
//                                     placeholder="N"
//                                     style={{ width: "100%" }}
//                                     value={devis.divers_multi || 0}
//                                     onChange={(value) =>
//                                       handleChange(index, "divers_multi", value)
//                                     }
//                                   />
//                                 </Col>
//                                 <Col span={11}>
//                                   <InputNumber
//                                     size="large"
//                                     style={{ width: "100%" }}
//                                     value={
//                                       (devis.divers || 0) *
//                                       (devis.divers_multi || 0)
//                                     }
//                                     disabled
//                                     formatter={(value) =>
//                                       `${value}`.replace(
//                                         /\B(?=(\d{3})+(?!\d))/g,
//                                         " "
//                                       )
//                                     }
//                                     parser={(value) => value.replace(/\s?/g, "")}
//                                   />
//                                 </Col>
//                               </Row>
//                             </Col>
//                           </Row>
//                         </>
//                       )}

//                       {currentStep === 2 && (
//                         <>
//                           <Divider>Frais et Dépenses</Divider>
//                           <Row gutter={16}>
//                             <Col span={6}>
//                               <label>Prix total gasoil</label>
//                               <InputNumber
//                                 size="large"
//                                 min={0}
//                                 style={{ width: "100%" }}
//                                 value={Number(devis.total_go)}
//                                 formatter={(value) =>
//                                   `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
//                                 }
//                                 parser={(value) => value.replace(/\s?/g, "")}
//                                 onChange={(value) =>
//                                   handleChange(index, "total_go", value)
//                                 }
//                                 precision={2}
//                               />
//                             </Col>
//                             <Col span={6}>
//                               <label>Prix total dépense</label>
//                               <InputNumber
//                                 size="large"
//                                 min={0}
//                                 style={{ width: "100%" }}
//                                 value={devis.total_depense}
//                                 formatter={(value) =>
//                                   `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
//                                 }
//                                 parser={(value) => value.replace(/\s?/g, "")}
//                                 onChange={(value) =>
//                                   handleChange(index, "total_depense", value)
//                                 }
//                                 precision={2}
//                               />
//                             </Col>
//                             <Col span={6}>
//                               <label>Prix total brute</label>
//                               <InputNumber
//                                 size="large"
//                                 min={0}
//                                 style={{ width: "100%" }}
//                                 value={devis.total_brut}
//                                 formatter={(value) =>
//                                   `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
//                                 }
//                                 parser={(value) => value.replace(/\s?/g, "")}
//                                 onChange={(value) =>
//                                   handleChange(index, "total_brut", value)
//                                 }
//                                 precision={2}
//                               />
//                             </Col>
//                           </Row>
//                           <br />
//                           <Row gutter={16}>
//                             <Col span={6}>
//                               <label>Bénéfice</label>
//                               <InputNumber
//                                 size="large"
//                                 min={0}
//                                 style={{ width: "100%" }}
//                                 value={devis.total_benefice}
//                                 formatter={(value) =>
//                                   `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
//                                 }
//                                 parser={(value) => value.replace(/\s?/g, "")}
//                                 onChange={(value) =>
//                                   handleChange(index, "total_benefice", value)
//                                 }
//                                 precision={2}
//                               />
//                             </Col>
//                           </Row>
//                         </>
//                       )}

//                       <Divider />
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                         }}
//                       >
//                         <Button
//                           disabled={currentStep === 0}
//                           onClick={() => setCurrentStep(currentStep - 1)}
//                         >
//                           Précédent
//                         </Button>

//                         {currentStep < steps.length - 1 ? (
//                           <Button
//                             type="primary"
//                             onClick={() => setCurrentStep(currentStep + 1)}
//                           >
//                             Suivant
//                           </Button>
//                         ) : (
//                           devis.statut_devis !== "valide_direction" && devis.statut_devis !== "valide_client" &&
//                           <Button
//                             type="primary"
//                             onClick={() => handleUpdate(devis)}
//                           >
//                             Mettre à jour
//                           </Button>
//                         )}
//                       </div>
//                     </div>
//                   </TabPane>
//                 )
//               })}
//           </Tabs>
//         </div>
//       </Modal>

//       <Modal
//         title="📋 Détails du devis sur les bennes"
//         open={modalBennevisible}
//         onCancel={closeModalBenne}
//         width="70%"
//         style={{ top: 0 }}
//         footer={[
//           <Button key="close" onClick={closeModalBenne}>
//             Fermer
//           </Button>,

//           updateBenne && <Button
//             key="update"
//             type="primary"
//             onClick={handleUpdateBennes}
//           >
//             Mettre à jour
//           </Button>,
//         ]}
//       >
//         <div
//           style={{
//             width: "100%",
//             height: "77vh",
//             paddingRight: "10px",
//             overflowY: "auto",
//           }}
//         >
//           <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
//             <Row gutter={16}>
//               <Col span={12}>
//                 <Row align="middle" gutter={8}>
//                   <Col span={10} style={{ textAlign: "center" }}>
//                     Clients
//                   </Col>
//                   <Col span={14}>
//                     <Select
//                       size="large"
//                       placeholder="Clients"
//                       style={{
//                         width: "100%",
//                         textAlign: "center",
//                         fontWeight: 600,
//                       }}
//                       value={selectedDevis?.[0]?.client_id ?? null}
//                       onChange={(value) => handleDevisBenneChange("client_id", value)}
//                     >
//                       {listeClient.map((r) => (
//                         <Option key={r.id} value={r.id}>
//                           {r.nom}
//                         </Option>
//                       ))}
//                     </Select>
//                   </Col>
//                 </Row>
//               </Col>
//               <Col span={8}>
//                 <Row align="middle" gutter={8}>
//                   <Col span={10} style={{ textAlign: "center" }}>
//                     Mode de paiement
//                   </Col>
//                   <Col span={14}>
//                     <Select
//                       size="large"
//                       style={{
//                         width: "100%",
//                         textAlign: "center",
//                         fontWeight: 600,
//                       }}
//                       value={selectedDevis?.[0]?.paiement ?? null}
//                       onChange={(value) => handleDevisBenneChange("paiement", value)}
//                     >
//                       <Option key="cheque" value="cheque"></Option>
//                       <Option key="mobile_money" value="Mobile Money"></Option>
//                       <Option key="espece" value="Espèces"></Option>
//                       <Option key="virement" value="Virement bancaire"></Option>
//                     </Select>
//                   </Col>
//                 </Row>
//               </Col>
//             </Row>
//             {
//               currentBennes && currentBennes.map((benne, index) => {
//                 return (
//                   <div
//                     key={index}
//                     style={{
//                       background: "#fff",
//                       padding: 18,
//                       borderRadius: 16,
//                       marginBottom: 14,
//                       border: "1px solid #f0f0f0",
//                       boxShadow: "0 3px 10px rgba(0,0,0,0.06)",
//                     }}
//                   >
//                     {/* Header */}
//                     <Row align="right">
//                       <Button
//                         danger
//                         type="text"
//                         onClick={() => removeBenne(index)}
//                         style={{ fontWeight: 500, float: "right" }}
//                       >
//                         🗑 Supprimer
//                       </Button>
//                     </Row>

//                     <div style={{ marginTop: 12 }} />

//                     {/* Formulaire */}
//                     <Row gutter={[12, 12]} align="middle">
//                       {/* Description */}
//                       <Col xs={24} md={6}>
//                         <label className="field-label">Description</label>
//                         <Input
//                           placeholder="Ex: Benne gravats"
//                           value={benne.description}
//                           onChange={(e) =>
//                             updateBenneField(index, "description", e.target.value)
//                           }
//                         />
//                       </Col>

//                       {/* Date */}
//                       <Col xs={12} md={4}>
//                         <label className="field-label">Date</label>
//                         <DatePicker
//                           style={{ width: "100%" }}
//                           value={moment(benne.date_location)}
//                           format="YYYY-MM-DD"
//                           onChange={(date) =>
//                             updateBenneField(index, "date_location", date)
//                           }
//                         />
//                       </Col>

//                       {/* Volume */}
//                       <Col xs={12} md={3}>
//                         <label className="field-label">Volume</label>
//                         <Select
//                           placeholder="m³"
//                           value={benne.volume}
//                           style={{ width: "100%" }}
//                           onChange={(val) =>
//                             updateBenneField(index, "volume", val)
//                           }
//                         >
//                           {volumetries.map((v) => (
//                             <Option key={v.value} value={v.value}>
//                               {v.label}
//                             </Option>
//                           ))}
//                         </Select>
//                       </Col>

//                       {/* Type */}
//                       <Col xs={12} md={4}>
//                         <label className="field-label">Type</label>
//                         <Select
//                           placeholder="Location / Propre"
//                           value={benne.situation}
//                           style={{ width: "100%" }}
//                           onChange={(val) =>
//                             updateBenneField(index, "situation", val)
//                           }
//                         >
//                           {locationTypes.map((t) => (
//                             <Option key={t.value} value={t.value}>
//                               {t.label}
//                             </Option>
//                           ))}
//                         </Select>
//                       </Col>

//                       {/* Quantité */}
//                       <Col xs={12} md={2}>
//                         <label className="field-label">Qté</label>
//                         <InputNumber
//                           min={1}
//                           value={benne.quantite}
//                           style={{ width: "100%" }}
//                           onChange={(val) =>
//                             updateBenneField(index, "quantite", val)
//                           }
//                         />
//                       </Col>

//                       {/* Prix */}
//                       <Col xs={12} md={3}>
//                         <label className="field-label">PU</label>
//                         <InputNumber
//                           min={0}
//                           value={benne.prix_unitaire}
//                           style={{ width: "100%" }}
//                           formatter={(v) =>
//                             `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
//                           }
//                           onChange={(val) =>
//                             updateBenneField(index, "prix_unitaire", val)
//                           }
//                         />
//                       </Col>

//                       {/* Total */}
//                       <Col xs={12} md={2}>
//                         <label className="field-label">Total</label>
//                         <InputNumber
//                           value={benne.prix_unitaire * benne.quantite}
//                           disabled
//                           style={{
//                             width: "100%",
//                             fontWeight: "bold",
//                             background: "#f6ffed",
//                             border: "1px solid #b7eb8f",
//                           }}
//                           formatter={(v) =>
//                             `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
//                           }
//                         />
//                       </Col>
//                     </Row>
//                   </div>
//                 )
//               })
//             }
//             <Button type="dashed" onClick={addBenne} style={{ width: "50%", alignSelf: "center" }}>
//               + Ajouter
//             </Button>
//             <br />
//             <Row justify="space-between" align="middle">
//               <h5 style={{ margin: 0 }}>💰 Frais & Perdiems</h5>
//               <Button type="primary" onClick={addFraisLine}>
//                 + Ajouter un frais
//               </Button>
//             </Row>
//             {currentFrais && currentFrais.map((frais, index) => (
//               <div
//                 key={index}
//                 style={{
//                   padding: 14,
//                   marginBottom: 12,
//                   borderRadius: 14,
//                   border: "1px solid #f0f0f0",
//                   background: "#fafafa",
//                 }}
//               >
//                 <Row gutter={[12, 12]} align="middle">
//                   {/* Type */}
//                   <Col xs={24} md={6}>
//                     <Select
//                       placeholder="Type de frais"
//                       style={{ width: "100%" }}
//                       value={frais.type}
//                       onChange={(val) =>
//                         updateFraisLine(index, "type", val)
//                       }
//                     >
//                       {fraisTypes.map((t) => (
//                         <Option key={t.value} value={t.value}>
//                           {t.label}
//                         </Option>
//                       ))}
//                     </Select>
//                   </Col>

//                   {/* Montant */}
//                   <Col xs={12} md={5}>
//                     <InputNumber
//                       min={0}
//                       placeholder="Montant"
//                       style={{ width: "100%" }}
//                       value={frais.montant}
//                       onChange={(val) =>
//                         updateFraisLine(index, "montant", val)
//                       }
//                       formatter={(v) =>
//                         `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
//                       }
//                     />
//                   </Col>

//                   {/* Multiplicateur */}
//                   <Col xs={12} md={3}>
//                     <InputNumber
//                       min={1}
//                       placeholder="N"
//                       style={{ width: "100%" }}
//                       value={frais.multiplicateur}
//                       onChange={(val) =>
//                         updateFraisLine(index, "multiplicateur", val)
//                       }
//                     />
//                   </Col>

//                   {/* Total */}
//                   <Col xs={12} md={5}>
//                     <InputNumber
//                       disabled
//                       style={{
//                         width: "100%",
//                         fontWeight: "bold",
//                         background: "#f6ffed",
//                         border: "1px solid #b7eb8f",
//                       }}
//                       value={frais.total}
//                       formatter={(v) =>
//                         `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
//                       }
//                     />
//                   </Col>

//                   {/* Supprimer */}
//                   <Col xs={12} md={2}>
//                     <Button danger onClick={() => removeFraisLine(index)}>
//                       ✕
//                     </Button>
//                   </Col>
//                 </Row>
//               </div>
//             ))}
//           </div>
//         </div>
//       </Modal>
//       {showToast && (
//         <Notification message={notif.message} status={notif.info} />
//       )}
//     </div>
//   );
// };

// export default Devis;

import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Button,
  Modal,
  Space,
  message,
  Tag,
  Select,
  Row,
  Col,
  DatePicker,
  InputNumber,
  Tabs,
  Divider,
  Steps,
  Radio,
  Spin,
} from "antd";
import {
  PlusOutlined,
  ReloadOutlined,
  SearchOutlined,
  EyeOutlined,
  CheckOutlined,
  FilePdfOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import {
  downloadDevis,
  duplicate_devis,
  export_devis,
  get_devis,
  getall_devis,
  merge_devis,
  toggle_devis,
  update_devis,
} from "../../api/devis";
import { get_ListeRegion } from "../../api/region";
import { get_all_agences, get_all_users } from "../../api/users";
import Notification from "../../composants/Notification";
import "moment/locale/fr";
import moment from "moment";
import { get_ListeClients } from "../../api/clients";
import { getPermissionsFromToken, hasPermission } from "../../utils/utils";

const { RangePicker } = DatePicker;
const { Option } = Select;
const { TabPane } = Tabs;

/* ───────────── Styles intégrés ───────────── */
const compactCss = `
.devis-page .dv-table .ant-table { font-size: 12px; }
.devis-page .dv-table .ant-table-thead > tr > th {
  font-size: 12px;
  padding: 6px 8px;
  white-space: nowrap;
}
.devis-page .dv-table .ant-table-tbody > tr > td { padding: 4px 8px; }
.devis-page .dv-table .ant-tag { margin-right: 0; }
.devis-page .dv-table .ant-btn-sm { padding: 0 6px; }
.devis-page .dv-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 12px;
}
.devis-page .dv-toolbar .dv-spacer { flex: 1; }
.dv-label,
.field-label {
  display: block;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 2px;
  line-height: 1.2;
}
.dv-modal-body {
  width: 100%;
  height: 77vh;
  padding-right: 10px;
  overflow-y: auto;
  font-size: 12px;
}
.dv-modal-body .ant-input,
.dv-modal-body .ant-input-number,
.dv-modal-body .ant-select,
.dv-modal-body .ant-radio-wrapper,
.dv-modal-body .ant-picker { font-size: 12px; }
.dv-modal-body .ant-divider { margin: 10px 0; font-size: 13px; }
`;

const volumetries = Array.from({ length: 27 }, (_, i) => ({
  label: `${10 + i} m³`,
  value: `${10 + i}`,
}));

const locationTypes = [
  { label: "Propre", value: "propre" },
  { label: "Location", value: "location" },
];

const fraisTypes = [
  { value: "perdiem_chauffeur", label: "Perdiem Chauffeur" },
  { value: "perdiem_aide", label: "Perdiem Aide" },
  { value: "credit", label: "Crédit" },
  { value: "parking", label: "Parking" },
  { value: "contravention", label: "Contravention" },
  { value: "divers", label: "Divers" },
  { value: "chargement", label: "Chargement" },
  { value: "dechargement", label: "Déchargement" },
  { value: "arrimage", label: "Arrimage" },
];

const paiementOptions = [
  { value: "cheque", label: "Chèque" },
  { value: "Mobile Money", label: "Mobile Money" },
  { value: "Espèces", label: "Espèces" },
  { value: "Virement bancaire", label: "Virement bancaire" },
];

const statutMap = {
  valide_direction: { color: "green", text: "Validé Masoandro" },
  invalide_direction: { color: "red", text: "Refusé Masoandro" },
  attente_masoandro: { color: "orange", text: "Attente Masoandro" },
  attente_client: { color: "blue", text: "Attente Client" },
  valide_client: { color: "cyan", text: "Validé Client" },
  invalide_client: { color: "magenta", text: "Refusé Client" },
};

const spaceFmt = (v) => `${v ?? ""}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
const spaceParse = (v) => (v ? v.replace(/\s/g, "") : v);

const Devis = () => {
  const [searchText, setSearchText] = useState("");
  const [listeDevis, setListeDevis] = useState([]);
  const [filteredDevis, setFilteredDevis] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDevis, setSelectedDevis] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalBennevisible, setModalBennevisible] = useState(false);
  const [listeRegion, setlisteRegion] = useState([]);
  const [listeUsers, setlisteUsers] = useState([]);
  const [validationModalVisible, setValidationModalVisible] = useState(false);
  const [duplicateModalVisible, setduplicateModalVisible] = useState(false);
  const [listeClient, setListeClients] = useState([]);
  const [validationStatus, setValidationStatus] = useState("valide_direction");
  const [devisToValidate, setDevisToValidate] = useState(null);
  const [showToast, setshowToast] = useState(false);
  const [notif, setnotif] = useState({
    message: null,
    info: null,
  });
  const [dateRange, setDateRange] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
  const [tableFilters, setTableFilters] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const rowSelection = {
    selectedRowKeys,
    onChange: (keys, rows) => {
      setSelectedRowKeys(keys);
      setSelectedRows(rows);
    },
    selections: [
      Table.SELECTION_ALL,
      Table.SELECTION_INVERT,
      Table.SELECTION_NONE,
    ],
  };
  const [showModalFusion, setshowModalFusion] = useState(false);
  const [optionFusion, setOptionFusion] = useState({
    tva: 0,
    acompte: 0,
    paiement: "cheque",
  });
  const [currentStep, setCurrentStep] = useState(0);
  const [temp, settemp] = useState({});
  const [listAgence, setListeAgence] = useState([]);
  const [currentBennes, setcurrentBennes] = useState([]);
  const [currentFrais, setCurrentFrais] = useState([]);
  const [updateBenne, setUpdateBenne] = useState(false);

  useEffect(() => {
    fetchListeAgence();
    fetchUsers();
    fetchListeClients();
    fetchRegions();
    fetchDevis();
  }, []);

  const fetchListeAgence = async () => {
    const res = await get_all_agences();
    if (res.status === "success") {
      setListeAgence(res.data);
    }
  };

  const fetchDevis = async (range = []) => {
    try {
      setLoading(true);
      let start, end;
      if (range.length === 2) {
        start = moment(range[0]).format("YYYY-MM-DD HH:mm:ss");
        end = moment(range[1]).format("YYYY-MM-DD");
      } else {
        end = moment().format("YYYY-MM-DD");
        start = moment().subtract(3, "months").format("YYYY-MM-DD HH:mm:ss");
      }
      const res = await getall_devis({ start, end });
      if (res.data && Array.isArray(res.data)) {
        setListeDevis(res.data);
        setFilteredDevis(res.data);
      } else {
        message.warning("Aucune donnée trouvée.");
      }
    } catch (error) {
      message.error("Erreur lors du chargement des devis");
    } finally {
      setLoading(false);
    }
  };

  const fetchRegions = async () => {
    const res = await get_ListeRegion();
    setlisteRegion(res.data || []);
  };

  const fetchUsers = async () => {
    const res = await get_all_users();
    setlisteUsers(res.data || []);
  };

  const fetchListeClients = async () => {
    const res = await get_ListeClients();
    setListeClients(res.data);
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    const filtered = listeDevis.filter((item) => {
      const ref = item.ref?.toLowerCase?.() || "";
      const desc = item.description?.toLowerCase?.() || "";
      const client = item.client_nom?.toLowerCase?.() || "";
      return (
        ref.includes(value) || desc.includes(value) || client.includes(value)
      );
    });
    setFilteredDevis(filtered);
  };

  const closeModal = () => {
    setSelectedDevis([]);
    setModalVisible(false);
  };

  const closeModalBenne = () => {
    setSelectedDevis([]);
    setModalBennevisible(false);
  };

  const openValidationModal = (record) => {
    setDevisToValidate(record);
    setValidationStatus(record.statut_devis || "pending");
    setValidationModalVisible(true);
  };

  const closeValidationModal = () => {
    setDevisToValidate(null);
    setValidationModalVisible(false);
  };

  const handleValidateDevis = async () => {
    if (!devisToValidate) return;

    const res = await toggle_devis(devisToValidate.id, validationStatus);
    console.log(res);
    if (res.status === "success") {
      setnotif({
        ...notif,
        message: "Devis mise à jour avec succés",
        info: "success",
      });
      setshowToast(true);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      message.warning("Erreur lors de la modification du devis !!!");
      setnotif({
        ...notif,
        message: "Erreur lors de la modification du devis !!!",
        info: "error",
      });
      setshowToast(true);
      setTimeout(() => {
        setshowToast(false);
      }, 1500);
    }
  };

  const handleDownload = async (record) => {
    try {
      await downloadDevis(record.id);
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        setnotif({
          ...notif,
          message: "Devis mise à jour avec succés",
          info: "success",
        });
        setshowToast(true);
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        throw error;
      }
    }
  };

  const fmt = (num, suffix = "") => {
    const n = Number(num);
    if (!isFinite(n)) return "-";
    return `${n.toLocaleString("fr-FR")} ${suffix}`.trim();
  };

  const handlegetdevisbyid = async (record) => {
    const res = await get_devis(record.id);
    console.log(res.data);
    setSelectedDevis(res.data);
    if (record.service === "BENNE") {
      if (record.statut_devis === "attente_masoandro") {
        setUpdateBenne(true);
      }
      const current = res.data[0]?.bennes;
      let parsedBennes = [];
      try {
        parsedBennes = current ? JSON.parse(current) : [];
      } catch (error) {
        console.error("Erreur parsing bennes:", error);
        parsedBennes = [];
      }

      const frais = [];
      const d = res.data[0] || {};
      fraisTypes.forEach(({ value }) => {
        const montant = d[value];
        const multi = d[`${value}_multi`];
        if (montant !== "0") {
          frais.push({
            type: value,
            montant,
            multiplicateur: multi,
            total: Number(montant) * Number(multi),
          });
        }
      });

      setCurrentFrais(frais);
      setcurrentBennes(parsedBennes);
      setModalBennevisible(true);
    } else {
      setModalVisible(true);
    }
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      align: "center",
      width: 60,
    },
    {
      title: "Création",
      dataIndex: "create_at",
      key: "create_at",
      align: "center",
      width: 120,
      render: (text) =>
        new Date(text).toISOString().slice(0, 16).replace("T", " "),
    },
    {
      title: "Service",
      dataIndex: "service",
      key: "service",
      width: 100,
      filters: Array.from(
        new Set(listeDevis?.map((item) => item.service).filter(Boolean))
      ).map((service) => ({
        text: service,
        value: service,
      })),
      onFilter: (value, record) => record.service === value,
      render: (service) => {
        let color = "blue";
        if (service === "TRANSPORT") color = "magenta";
        if (service === "BENNE") color = "PURPLE";
        return <Tag color={color}>{service}</Tag>;
      },
    },
    {
      title: "Départ",
      dataIndex: "region_depart",
      key: "region_depart",
      width: 110,
      filters: listeRegion.map((r) => ({
        text: r.nom,
        value: r.id,
      })),
      onFilter: (value, record) => record.region_depart === value,
      render: (rd) => {
        const reg = listeRegion.find((u) => u.id === rd);
        return <Tag color="gold">{reg ? reg.nom : "Inconnu"}</Tag>;
      },
    },
    {
      title: "Destination",
      dataIndex: "region_arrive",
      key: "region_arrive",
      width: 110,
      filters: listeRegion.map((r) => ({
        text: r.nom,
        value: r.id,
      })),
      onFilter: (value, record) => record.region_arrive === value,
      render: (rd) => {
        const reg = listeRegion.find((u) => u.id === rd);
        return <Tag color="green">{reg ? reg.nom : "Inconnu"}</Tag>;
      },
    },
    {
      title: "Référence",
      dataIndex: "ref",
      key: "ref",
      width: 130,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Rechercher..."
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button type="primary" onClick={() => confirm()} size="small">
              Rechercher
            </Button>
            <Button onClick={() => clearFilters()} size="small">
              Réinitialiser
            </Button>
          </Space>
        </div>
      ),
      onFilter: (value, record) =>
        record.ref?.toLowerCase().includes(value.toLowerCase()),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ),
    },
    {
      title: "Client",
      dataIndex: "client_nom",
      key: "client_nom",
      width: 150,
      ellipsis: true,
      filters: Array.from(
        new Set(listeDevis.map((item) => item.client_nom))
      ).map((name) => ({
        text: name,
        value: name,
      })),
      onFilter: (value, record) => record.client_nom === value,
    },
    {
      title: "Utilisateur",
      dataIndex: "user_create_id",
      key: "user_create_id",
      align: "center",
      width: 140,
      filters: listAgence.map((a) => ({
        text: a.nom,
        value: `agence_${a.id}`,
      })),
      onFilter: (value, record) => {
        const user = listeUsers.find((u) => u.id === record.user_create_id);
        if (!user) return false;

        if (value.startsWith("agence_")) {
          const agenceId = Number(value.split("_")[1]);
          return user.agence_id === agenceId;
        }
        return user.id === value;
      },
      render: (_, record) => {
        const user = listeUsers.find((u) => u.id === record.user_create_id);
        if (!user) return "—";

        const agence = listAgence.find((a) => a.id === user.agence_id);
        const fullName = `${user.prenom} ${user.nom}`;
        const fonctionTagColor = user.fonction_id === 1 ? "blue" : "green";

        return (
          <Space direction="vertical" size={2}>
            <Tag color={fonctionTagColor}>{fullName}</Tag>
            {agence && <Tag color="orange">{agence.nom}</Tag>}
          </Space>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "statut_devis",
      key: "statut_devis",
      align: "center",
      width: 150,
      filters: Object.entries(statutMap).map(([value, { text }]) => ({
        text,
        value,
      })),
      onFilter: (value, record) => record.statut_devis === value,
      render: (status) => {
        const s = statutMap[status] || { color: "default", text: "Inconnu" };
        return (
          <Tag color={s.color} style={{ margin: 0, fontSize: 11 }}>
            {s.text}
          </Tag>
        );
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 180,
      ellipsis: true,
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      fixed: "right",
      width: 150,
      render: (_, record) => (
        <Space size={4}>
          {hasPermission(getPermissionsFromToken(), "DEVIS_VIEW") && (
            <Button
              size="small"
              className="btn btn-info btn-sm"
              onClick={() => handlegetdevisbyid(record)}
              title="Voir le devis"
            >
              <EyeOutlined />
            </Button>
          )}

          {record.service !== "BENNE" &&
            hasPermission(getPermissionsFromToken(), "DEVIS_DUPLICATE") && (
              <Button
                size="small"
                className="btn btn-warning btn-sm"
                disabled={record.isparent === 1}
                onClick={() => {
                  setSelectedDevis([record]);
                  setduplicateModalVisible(true);
                }}
                title={
                  record.isparent === 1
                    ? "Duplication impossible pour un parent"
                    : "Dupliquer le devis"
                }
              >
                <CopyOutlined />
              </Button>
            )}

          {hasPermission(getPermissionsFromToken(), "DEVIS_CHANGE_STATUS") && (
            <Button
              size="small"
              className="btn btn-success btn-sm"
              onClick={() => openValidationModal(record)}
              title="Valider le devis"
            >
              <CheckOutlined />
            </Button>
          )}

          {hasPermission(getPermissionsFromToken(), "DEVIS_DOWNLOAD") &&
            ["valide_direction", "valide_client"].includes(
              record.statut_devis
            ) && (
              <Button
                size="small"
                onClick={() => handleDownload(record)}
                className="btn btn-secondary btn-sm"
                title="Télécharger le devis"
              >
                <FilePdfOutlined />
              </Button>
            )}
        </Space>
      ),
    },
  ];

  const handleDateChange = (dates) => {
    setDateRange(dates);
  };

  const handleTableChange = (pag, filters, sorter) => {
    setPagination(pag);
    setTableFilters(filters);
  };

  const handleExport = async () => {
    const params = new URLSearchParams();
    if (dateRange.length === 2) {
      params.append(
        "start",
        moment(dateRange[0]).format("YYYY-MM-DD HH:mm:ss")
      );
      params.append("end", moment(dateRange[1]).format("YYYY-MM-DD HH:mm:ss"));
    } else {
      params.append("end", moment().format("YYYY-MM-DD HH:mm:ss"));
      params.append(
        "start",
        moment().subtract(3, "months").format("YYYY-MM-DD HH:mm:ss")
      );
    }
    if (tableFilters.region_depart?.length)
      params.append("region_depart", tableFilters.region_depart.join(","));
    if (tableFilters.region_arrive?.length)
      params.append("region_arrive", tableFilters.region_arrive.join(","));
    if (tableFilters.client_nom?.length)
      params.append("client", tableFilters.client_nom.join(","));
    if (tableFilters.user_create_id?.length)
      params.append("commercial", tableFilters.user_create_id.join(","));
    if (tableFilters.statut_devis?.length)
      params.append("statut", tableFilters.statut_devis.join(","));

    await export_devis(params.toString());
  };

  const handleMergedExport = async () => {
    const listId = selectedRows.map((i) => i.id);
    const res = await merge_devis(listId, optionFusion);
    if (res.status === "success") {
      setnotif({
        ...notif,
        message: "Devis dupliqué avec succés",
        info: "success",
      });
      setshowToast(true);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      setnotif({
        ...notif,
        message: "Devis non dupliqué !!!",
        info: "error",
      });
      setshowToast(true);
      setTimeout(() => {
        setshowToast(false);
      }, 1500);
    }
  };

  const handleDuplicate = async () => {
    const res = await duplicate_devis(selectedDevis[0].id);
    console.log(res);
    if (res.status === "success") {
      setnotif({
        ...notif,
        message: "Devis dupliqué avec succés",
        info: "success",
      });
      setshowToast(true);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      setnotif({
        ...notif,
        message: "Devis non dupliqué !!!",
        info: "error",
      });
      setshowToast(true);
      setTimeout(() => {
        setshowToast(false);
      }, 1500);
    }
  };

  const handleUpdate = async (devis) => {
    console.log("Mise à jour du devis :", devis);
    message.success(`Devis ${devis.ref} mis à jour avec succès`);
    const res = await update_devis(devis);
    console.log(res.status);
    if (res.status === "success") {
      setnotif({
        ...notif,
        message: "Devis mise à jour avec succés",
        info: "success",
      });
      setshowToast(true);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      setnotif({
        ...notif,
        message: "Error mise à jour !!!!",
        info: "error",
      });
      setshowToast(true);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  };

  const steps = [
    "Informations générales",
    "Frais & Dépenses",
    "Résumé & Modification",
  ];

  const handleChange = (index, key, value) => {
    const newList = [...selectedDevis];
    const devis = { ...newList[index], [key]: value };

    // auto calcul des coefficients
    const coef_aller =
      devis.status_aller === 1
        ? devis.coefficient_charge
        : devis.coefficient_vide;

    const coef_retour =
      devis.status_retour === 1
        ? devis.coefficient_charge
        : devis.coefficient_vide;
    const carburant_aller = devis.distance * coef_aller;
    const carburant_retour = devis.distance * coef_retour;
    const total_carburant = carburant_aller + carburant_retour;
    const total_gasoil = Number(total_carburant * devis.prix_go).toFixed(2);
    const total_brute = devis.cotation * devis.poids;
    // Calcul auto du total dépense
    const total_frais =
      (devis.perdiem_chauffeur || 0) * (devis.perdiem_chauffeur_multi || 0) +
      (devis.perdiem_aide || 0) * (devis.perdiem_aide_multi || 0) +
      (devis.credit || 0) * (devis.credit_multi || 0) +
      (devis.parking || 0) * (devis.parking_multi || 0) +
      (devis.contravention || 0) * (devis.contravention_multi || 0) +
      (devis.divers || 0) * (devis.divers_multi || 0) +
      (devis.chargement || 0) * (devis.chargement_multi || 0) +
      (devis.dechargement || 0) * (devis.dechargement_multi || 0) +
      (devis.arrimage || 0) * (devis.arrimage_multi || 0);
    const total_benefice = total_brute - total_gasoil - total_frais;

    devis.total_brut = total_brute;
    devis.total_depense = total_frais;
    devis.total_benefice = total_benefice;
    devis.total_go = total_gasoil;
    devis.total_carburant = total_carburant;
    devis.carburant_aller = carburant_aller;
    devis.carburant_retour = carburant_retour;

    newList[index] = devis;
    setSelectedDevis(newList);
  };

  const addFraisLine = () => {
    setCurrentFrais((prev) => [
      ...prev,
      {
        type: null,
        montant: 0,
        multiplicateur: 1,
        total: 0,
      },
    ]);
  };

  const removeFraisLine = (index) => {
    setCurrentFrais((prev) => prev.filter((_, i) => i !== index));
  };

  const updateFraisLine = (index, field, value) => {
    setCurrentFrais((prev) => {
      const newFrais = [...prev];

      newFrais[index] = {
        ...newFrais[index],
        [field]: value,
      };

      const m = Number(newFrais[index].montant) || 0;
      const mult = Number(newFrais[index].multiplicateur) || 0;
      newFrais[index].total = m * mult;

      return newFrais;
    });
  };

  const handleDevisBenneChange = (field, value, index = 0) => {
    setSelectedDevis((prev) => {
      if (!prev || !prev.length) return prev;
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [field]: value,
      };
      return updated;
    });
  };

  const removeBenne = (index) => {
    const newBennes = currentBennes.filter((_, i) => i !== index);
    setcurrentBennes(newBennes);
  };

  const addBenne = () => {
    setcurrentBennes([
      ...currentBennes,
      {
        description: "",
        date_location: moment(),
        volume: "20",
        situation: "propre",
        quantite: 0,
        prix_unitaire: 0,
        total: 0,
      },
    ]);
  };

  const updateBenneField = (index, field, value) => {
    const newBennes = [...currentBennes];
    newBennes[index][field] = value;
    const qte = newBennes[index].quantite || 0;
    const pu = newBennes[index].prix_unitaire || 0;
    newBennes[index].total = qte * pu;
    setcurrentBennes(newBennes);
  };

  const handleUpdateBennes = async () => {
    const baseDevis = selectedDevis?.[0];

    if (!baseDevis) return;

    const payload = {
      ...baseDevis,
      bennes: JSON.stringify(currentBennes),
    };

    // remise à zéro de tous les frais, puis réapplication depuis currentFrais
    fraisTypes.forEach(({ value }) => {
      payload[value] = 0;
      payload[`${value}_multi`] = 0;
    });

    currentFrais.forEach((elem) => {
      if (fraisTypes.some((t) => t.value === elem.type)) {
        payload[elem.type] = elem.montant;
        payload[`${elem.type}_multi`] = elem.multiplicateur;
      }
    });

    const res = await update_devis(payload);
    if (res.status === "success") {
      setnotif({
        ...notif,
        message: "Devis mise à jour avec succés",
        info: "success",
      });
      setSelectedDevis([]);
      setshowToast(true);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      setnotif({
        ...notif,
        message: "Error mise à jour !!!!",
        info: "error",
      });
      setSelectedDevis([]);
      setshowToast(true);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  };

  /* ───────────── Rendu d'un champ de frais (montant × N = total) ───────────── */
  const renderFrais = (devis, index, key, label) => (
    <Col span={8} key={key}>
      <label className="dv-label">{label}</label>
      <Row align="middle" gutter={4} wrap={false}>
        <Col flex="38%">
          <InputNumber
            size="small"
            min={0}
            style={{ width: "100%" }}
            value={devis[key]}
            formatter={spaceFmt}
            parser={spaceParse}
            onChange={(value) => handleChange(index, key, value)}
          />
        </Col>
        <Col flex="18%">
          <InputNumber
            size="small"
            min={0}
            placeholder="N"
            style={{ width: "100%" }}
            value={devis[`${key}_multi`] || 0}
            onChange={(value) => handleChange(index, `${key}_multi`, value)}
          />
        </Col>
        <Col flex="auto">
          <InputNumber
            size="small"
            style={{ width: "100%" }}
            value={(devis[key] || 0) * (devis[`${key}_multi`] || 0)}
            disabled
            formatter={spaceFmt}
            parser={spaceParse}
          />
        </Col>
      </Row>
    </Col>
  );

  const renderMontant = (devis, index, key, label) => (
    <Col span={8} key={key}>
      <label className="dv-label">{label}</label>
      <InputNumber
        size="small"
        min={0}
        style={{ width: "100%" }}
        value={key === "total_go" ? Number(devis[key]) : devis[key]}
        formatter={spaceFmt}
        parser={spaceParse}
        onChange={(value) => handleChange(index, key, value)}
        precision={2}
      />
    </Col>
  );

  return (
    <div className="p-0 devis-page">
      <style>{compactCss}</style>

      {/* HEADER */}
      <div className="dv-toolbar">
        <Input
          placeholder="🔍 Rechercher..."
          value={searchText}
          onChange={handleSearch}
          prefix={<SearchOutlined />}
          style={{ width: 250 }}
        />
        <RangePicker
          showTime={{
            defaultValue: [
              moment("00:00:00", "HH:mm:ss"),
              moment("00:00:00", "HH:mm:ss"),
            ],
          }}
          onChange={handleDateChange}
          size="small"
        />
        <Button
          icon={<ReloadOutlined />}
          onClick={() => fetchDevis(dateRange)}
          loading={loading}
          style={{
            backgroundColor: "#0d6efd",
            borderColor: "#0d6efd",
            color: "#fff",
          }}
        >
          Recharger
        </Button>

        {hasPermission(getPermissionsFromToken(), "DEVIS_FUSIONNER") && (
          <Button
            type="primary"
            onClick={() => setshowModalFusion(true)}
            disabled={selectedRows.length < 2}
            style={{
              backgroundColor: "#0dcaf0",
              borderColor: "#0dcaf0",
              color: "#fff",
            }}
          >
            Fusionner
          </Button>
        )}

        <div className="dv-spacer" />

        {hasPermission(getPermissionsFromToken(), "DEVIS_EXPORT") && (
          <Button
            icon={<PlusOutlined />}
            style={{
              backgroundColor: "#198754",
              borderColor: "#198754",
              color: "#fff",
            }}
            onClick={handleExport}
          >
            Exporter
          </Button>
        )}
      </div>

      <Spin spinning={loading}>
        <Table
          className="dv-table"
          size="small"
          rowKey="id"
          columns={columns}
          dataSource={filteredDevis}
          loading={loading}
          sticky
          scroll={{ x: 1300, y: "calc(70vh - 110px)" }}
          pagination={{
            pageSize: 8,
            position: ["bottomCenter"],
            className: "custom-pagination",
            style: {
              display: "flex",
              justifyContent: "center",
              marginTop: 12,
            },
            itemRender: (page, type, originalElement) => {
              if (type === "page") {
                return (
                  <div
                    style={{
                      borderRadius: "50%",
                      minWidth: 32,
                      height: 32,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid #d9d9d9",
                    }}
                  >
                    {page}
                  </div>
                );
              }
              return originalElement;
            },
          }}
          onChange={handleTableChange}
          rowSelection={rowSelection}
        />
      </Spin>

      {/* MODAL VALIDATION */}
      <Modal
        title={`Valider le devis ${devisToValidate?.ref || ""}`}
        open={validationModalVisible}
        onCancel={closeValidationModal}
        footer={[
          <Button key="cancel" onClick={closeValidationModal}>
            Annuler
          </Button>,
          <Button key="confirm" type="primary" onClick={handleValidateDevis}>
            Confirmer
          </Button>,
        ]}
      >
        <Row align="middle">
          <Col span={6}>
            <p style={{ margin: 0 }}>Choisir le statut :</p>
          </Col>
          <Col span={18} style={{ padding: 10 }}>
            <Select
              value={validationStatus}
              onChange={(val) => setValidationStatus(val)}
              style={{ width: "100%" }}
            >
              {hasPermission(getPermissionsFromToken(), "VALIDATE_DEVIS") && (
                <Option value="valide_direction">Validé par Masoandro</Option>
              )}
              {hasPermission(getPermissionsFromToken(), "VALIDATE_DEVIS") && (
                <Option value="invalide_direction">Invalidé par Masoandro</Option>
              )}
              <Option value="attente_masoandro">
                En attente de validation Masoandro
              </Option>
              <Option value="attente_client">
                En attente de validation Client
              </Option>
              <Option value="valide_client">Validé par le Client</Option>
              <Option value="invalide_client">Invalidé par le Client</Option>
            </Select>
          </Col>
        </Row>
      </Modal>

      {/* MODAL FUSION */}
      <Modal
        title={"Fusion des devis"}
        open={showModalFusion}
        onCancel={() => {
          setSelectedRows([]);
          setshowModalFusion(false);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setSelectedRows([]);
              setshowModalFusion(false);
            }}
          >
            Annuler
          </Button>,
          <Button key="confirm" type="primary" onClick={handleMergedExport}>
            Confirmer
          </Button>,
        ]}
      >
        <Row align="middle">
          <Col span={6}>TVA</Col>
          <Col span={18} style={{ padding: 6 }}>
            <InputNumber
              min={0}
              max={100}
              addonAfter="%"
              style={{ width: "100%" }}
              value={optionFusion.tva || 0}
              onChange={(value) =>
                setOptionFusion({ ...optionFusion, tva: value })
              }
            />
          </Col>
        </Row>
        <Row align="middle">
          <Col span={6}>Acompte</Col>
          <Col span={18} style={{ padding: 6 }}>
            <InputNumber
              min={0}
              max={100}
              addonAfter="%"
              style={{ width: "100%" }}
              value={optionFusion.acompte || 0}
              onChange={(value) =>
                setOptionFusion({ ...optionFusion, acompte: value })
              }
            />
          </Col>
        </Row>
        <Row align="middle">
          <Col span={6}>Paiement</Col>
          <Col span={18} style={{ padding: 6 }}>
            <Select
              style={{ width: "100%", textAlign: "center", fontWeight: 600 }}
              value={optionFusion.paiement}
              options={paiementOptions}
              onChange={(value) =>
                setOptionFusion((prev) => ({ ...prev, paiement: value }))
              }
            />
          </Col>
        </Row>
      </Modal>

      {/* MODAL DUPLICATION */}
      <Modal
        title={`Dupliquer le devis ${selectedDevis?.[0]?.ref || ""}`}
        open={duplicateModalVisible}
        onCancel={() => {
          setduplicateModalVisible(false);
          setSelectedDevis([]);
          settemp({});
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setduplicateModalVisible(false);
              setSelectedDevis([]);
              settemp({});
            }}
          >
            Annuler
          </Button>,
          <Button key="confirm" type="primary" onClick={handleDuplicate}>
            Confirmer
          </Button>,
        ]}
      >
        <div style={{ textAlign: "center", width: "100%" }}>
          Voulez vous vraiement dupliquer ce devis ?
        </div>
      </Modal>

      {/* MODAL DÉTAILS DEVIS */}
      <Modal
        title={`📋 Détails du devis `}
        open={modalVisible}
        onCancel={closeModal}
        footer={[
          <Button key="close" onClick={closeModal}>
            Fermer
          </Button>,
        ]}
        width="70%"
        style={{ top: 0 }}
      >
        <div className="dv-modal-body">
          <Tabs
            className="custom-tabs"
            size="small"
            defaultActiveKey={selectedDevis?.[0]?.ref}
          >
            {selectedDevis &&
              selectedDevis.map((devis, index) => {
                return (
                  <TabPane tab={devis.ref} key={devis.ref}>
                    <div
                      style={{
                        borderRadius: 8,
                        backgroundColor: "#fafafa",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                        padding: 12,
                      }}
                    >
                      <Steps
                        current={currentStep}
                        onChange={setCurrentStep}
                        style={{ marginBottom: 12 }}
                        size="small"
                        items={steps.map((title) => ({ title }))}
                      />

                      {currentStep === 0 && (
                        <>
                          <Divider>Informations générales</Divider>
                          <Row gutter={[16, 10]}>
                            <Col span={8}>
                              <label className="dv-label">Client</label>
                              <Select
                                size="small"
                                placeholder="Clients"
                                style={{ width: "100%", fontWeight: 600 }}
                                value={devis.client_id}
                                onChange={(value) =>
                                  handleChange(index, "client_id", value)
                                }
                                disabled
                              >
                                {listeClient.map((r) => (
                                  <Option key={r.id} value={r.id}>
                                    {r.nom}
                                  </Option>
                                ))}
                              </Select>
                            </Col>
                            <Col span={8}>
                              <label className="dv-label">Contact</label>
                              <Input
                                size="small"
                                value={devis.contact_client}
                                onChange={(e) =>
                                  handleChange(index, "contact_client", e.target.value)
                                }
                                disabled
                              />
                            </Col>
                            <Col span={8}>
                              <label className="dv-label">Téléphone</label>
                              <Input
                                size="small"
                                value={devis.telephone_client}
                                onChange={(e) =>
                                  handleChange(index, "telephone_client", e.target.value)
                                }
                                disabled
                              />
                            </Col>

                            <Col span={8}>
                              <label className="dv-label">Région départ</label>
                              <Select
                                size="small"
                                placeholder="Choisir la région"
                                style={{ width: "100%" }}
                                value={devis.region_depart}
                                onChange={(value) =>
                                  handleChange(index, "region_depart", value)
                                }
                              >
                                {listeRegion.map((r) => (
                                  <Option key={r.id} value={r.id}>
                                    {r.nom}
                                  </Option>
                                ))}
                              </Select>
                            </Col>
                            <Col span={8}>
                              <label className="dv-label">Région arrivée</label>
                              <Select
                                size="small"
                                placeholder="Choisir la région"
                                style={{ width: "100%" }}
                                value={devis.region_arrive}
                                onChange={(value) =>
                                  handleChange(index, "region_arrive", value)
                                }
                              >
                                {listeRegion.map((r) => (
                                  <Option key={r.id} value={r.id}>
                                    {r.nom}
                                  </Option>
                                ))}
                              </Select>
                            </Col>
                            <Col span={8}>
                              <label className="dv-label">Cotation</label>
                              <InputNumber
                                size="small"
                                value={Number(
                                  (devis.cotation * devis.coefficient_distance).toFixed(2)
                                )}
                                onChange={(value) =>
                                  handleChange(index, "cotation", value)
                                }
                                style={{ width: "100%" }}
                              />
                            </Col>

                            <Col span={8}>
                              <label className="dv-label">Date départ</label>
                              <DatePicker
                                size="small"
                                showTime
                                style={{ width: "100%" }}
                                format="YYYY-MM-DD HH:mm:ss"
                                value={devis.date_depart ? moment(devis.date_depart) : null}
                                onChange={(date) =>
                                  handleChange(
                                    index,
                                    "date_depart",
                                    date ? date.toISOString() : null
                                  )
                                }
                              />
                            </Col>
                            <Col span={8}>
                              <label className="dv-label">Date arrivée</label>
                              <DatePicker
                                size="small"
                                showTime
                                style={{ width: "100%" }}
                                format="YYYY-MM-DD HH:mm:ss"
                                value={devis.date_arrive ? moment(devis.date_arrive) : null}
                                onChange={(date) =>
                                  handleChange(
                                    index,
                                    "date_arrive",
                                    date ? date.toISOString() : null
                                  )
                                }
                              />
                            </Col>
                            <Col span={4}>
                              <label className="dv-label">Distance (km)</label>
                              <InputNumber
                                size="small"
                                value={devis.distance}
                                onChange={(value) =>
                                  handleChange(index, "distance", value)
                                }
                                style={{ width: "100%" }}
                              />
                            </Col>
                            <Col span={4}>
                              <label className="dv-label">Poids (kg)</label>
                              <InputNumber
                                size="small"
                                value={devis.poids}
                                onChange={(value) =>
                                  handleChange(index, "poids", value)
                                }
                                style={{ width: "100%" }}
                              />
                            </Col>

                            <Col span={8}>
                              <label className="dv-label">Status aller</label>
                              <Radio.Group
                                size="small"
                                value={Number(devis.status_aller)}
                                onChange={(e) =>
                                  handleChange(index, "status_aller", Number(e.target.value))
                                }
                              >
                                <Radio value={1}>Chargé</Radio>
                                <Radio value={0}>Vide</Radio>
                              </Radio.Group>
                            </Col>
                            <Col span={8}>
                              <label className="dv-label">Status retour</label>
                              <Radio.Group
                                size="small"
                                value={Number(devis.status_retour)}
                                onChange={(e) =>
                                  handleChange(index, "status_retour", Number(e.target.value))
                                }
                              >
                                <Radio value={1}>Chargé</Radio>
                                <Radio value={0}>Vide</Radio>
                              </Radio.Group>
                            </Col>
                            <Col span={4}>
                              <label className="dv-label">Coef. chargé</label>
                              <InputNumber
                                size="small"
                                value={devis.coefficient_charge}
                                onChange={(value) =>
                                  handleChange(index, "coefficient_charge", value)
                                }
                                style={{ width: "100%" }}
                              />
                            </Col>
                            <Col span={4}>
                              <label className="dv-label">Coef. vide</label>
                              <InputNumber
                                size="small"
                                value={devis.coefficient_vide}
                                onChange={(value) =>
                                  handleChange(index, "coefficient_vide", value)
                                }
                                style={{ width: "100%" }}
                              />
                            </Col>

                            <Col span={8}>
                              <label className="dv-label">Carburant aller (L)</label>
                              <InputNumber
                                size="small"
                                value={devis.carburant_aller}
                                onChange={(value) =>
                                  handleChange(index, "carburant_aller", value)
                                }
                                style={{ width: "100%" }}
                                precision={2}
                              />
                            </Col>
                            <Col span={8}>
                              <label className="dv-label">Carburant retour (L)</label>
                              <InputNumber
                                size="small"
                                value={devis.carburant_retour}
                                onChange={(value) =>
                                  handleChange(index, "carburant_retour", value)
                                }
                                style={{ width: "100%" }}
                                precision={2}
                              />
                            </Col>
                            <Col span={8}>
                              <label className="dv-label">Carburant total (L)</label>
                              <InputNumber
                                size="small"
                                value={devis.total_carburant}
                                onChange={(value) =>
                                  handleChange(index, "total_carburant", value)
                                }
                                style={{ width: "100%" }}
                                precision={2}
                              />
                            </Col>
                          </Row>
                        </>
                      )}

                      {currentStep === 1 && (
                        <>
                          <Divider>Carburant & Perdiem</Divider>
                          <Row gutter={[16, 10]}>
                            {renderFrais(devis, index, "perdiem_chauffeur", "Perdiem chauffeur")}
                            {renderFrais(devis, index, "perdiem_aide", "Perdiem aide chauffeur")}
                            {renderFrais(devis, index, "parking", "Parking")}
                            {renderFrais(devis, index, "credit", "Crédit")}
                            {renderFrais(devis, index, "chargement", "Chargement")}
                            {renderFrais(devis, index, "dechargement", "Déchargement")}
                            {renderFrais(devis, index, "contravention", "Contravention")}
                            {renderFrais(devis, index, "arrimage", "Arrimage")}
                            {renderFrais(devis, index, "divers", "Divers")}
                          </Row>
                        </>
                      )}

                      {currentStep === 2 && (
                        <>
                          <Divider>Frais et Dépenses</Divider>
                          <Row gutter={[16, 10]}>
                            {renderMontant(devis, index, "total_go", "Prix total gasoil (Ar)")}
                            {renderMontant(devis, index, "total_depense", "Prix total dépense (Ar)")}
                            {renderMontant(devis, index, "total_brut", "Prix total brut (Ar)")}
                            {renderMontant(devis, index, "total_benefice", "Bénéfice (Ar)")}
                          </Row>
                        </>
                      )}

                      <Divider />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          size="small"
                          disabled={currentStep === 0}
                          onClick={() => setCurrentStep(currentStep - 1)}
                        >
                          Précédent
                        </Button>

                        {currentStep < steps.length - 1 ? (
                          <Button
                            size="small"
                            type="primary"
                            onClick={() => setCurrentStep(currentStep + 1)}
                          >
                            Suivant
                          </Button>
                        ) : (
                          devis.statut_devis !== "valide_direction" &&
                          devis.statut_devis !== "valide_client" && (
                            <Button
                              size="small"
                              type="primary"
                              onClick={() => handleUpdate(devis)}
                            >
                              Mettre à jour
                            </Button>
                          )
                        )}
                      </div>
                    </div>
                  </TabPane>
                );
              })}
          </Tabs>
        </div>
      </Modal>

      {/* MODAL DÉTAILS BENNES */}
      <Modal
        title="📋 Détails du devis sur les bennes"
        open={modalBennevisible}
        onCancel={closeModalBenne}
        width="70%"
        style={{ top: 0}}
        footer={[
          <Button key="close" onClick={closeModalBenne}>
            Fermer
          </Button>,
          updateBenne && (
            <Button key="update" type="primary" onClick={handleUpdateBennes}>
              Mettre à jour
            </Button>
          ),
        ]}
      >
        <div className="dv-modal-body">
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <Row gutter={16}>
              <Col span={12}>
                <label className="dv-label">Client</label>
                <Select
                  size="small"
                  placeholder="Clients"
                  style={{ width: "100%", fontWeight: 600 }}
                  value={selectedDevis?.[0]?.client_id ?? null}
                  onChange={(value) => handleDevisBenneChange("client_id", value)}
                >
                  {listeClient.map((r) => (
                    <Option key={r.id} value={r.id}>
                      {r.nom}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col span={12}>
                <label className="dv-label">Mode de paiement</label>
                <Select
                  size="small"
                  style={{ width: "100%", fontWeight: 600 }}
                  value={selectedDevis?.[0]?.paiement ?? null}
                  options={paiementOptions}
                  onChange={(value) => handleDevisBenneChange("paiement", value)}
                />
              </Col>
            </Row>

            {currentBennes &&
              currentBennes.map((benne, index) => (
                <div
                  key={index}
                  style={{
                    background: "#fff",
                    padding: 12,
                    borderRadius: 12,
                    border: "1px solid #f0f0f0",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                  }}
                >
                  <div style={{ textAlign: "right" }}>
                    <Button
                      danger
                      type="text"
                      size="small"
                      onClick={() => removeBenne(index)}
                      style={{ fontWeight: 500 }}
                    >
                      🗑 Supprimer
                    </Button>
                  </div>

                  <Row gutter={[10, 8]} align="middle">
                    <Col xs={24} md={6}>
                      <label className="field-label">Description</label>
                      <Input
                        size="small"
                        placeholder="Ex: Benne gravats"
                        value={benne.description}
                        onChange={(e) =>
                          updateBenneField(index, "description", e.target.value)
                        }
                      />
                    </Col>

                    <Col xs={12} md={4}>
                      <label className="field-label">Date</label>
                      <DatePicker
                        size="small"
                        style={{ width: "100%" }}
                        value={moment(benne.date_location)}
                        format="YYYY-MM-DD"
                        onChange={(date) =>
                          updateBenneField(index, "date_location", date)
                        }
                      />
                    </Col>

                    <Col xs={12} md={3}>
                      <label className="field-label">Volume</label>
                      <Select
                        size="small"
                        placeholder="m³"
                        value={benne.volume}
                        style={{ width: "100%" }}
                        onChange={(val) => updateBenneField(index, "volume", val)}
                      >
                        {volumetries.map((v) => (
                          <Option key={v.value} value={v.value}>
                            {v.label}
                          </Option>
                        ))}
                      </Select>
                    </Col>

                    <Col xs={12} md={4}>
                      <label className="field-label">Type</label>
                      <Select
                        size="small"
                        placeholder="Location / Propre"
                        value={benne.situation}
                        style={{ width: "100%" }}
                        onChange={(val) => updateBenneField(index, "situation", val)}
                      >
                        {locationTypes.map((t) => (
                          <Option key={t.value} value={t.value}>
                            {t.label}
                          </Option>
                        ))}
                      </Select>
                    </Col>

                    <Col xs={12} md={2}>
                      <label className="field-label">Qté</label>
                      <InputNumber
                        size="small"
                        min={1}
                        value={benne.quantite}
                        style={{ width: "100%" }}
                        onChange={(val) => updateBenneField(index, "quantite", val)}
                      />
                    </Col>

                    <Col xs={12} md={3}>
                      <label className="field-label">PU (Ar)</label>
                      <InputNumber
                        size="small"
                        min={0}
                        value={benne.prix_unitaire}
                        style={{ width: "100%" }}
                        formatter={spaceFmt}
                        onChange={(val) => updateBenneField(index, "prix_unitaire", val)}
                      />
                    </Col>

                    <Col xs={12} md={2}>
                      <label className="field-label">Total</label>
                      <InputNumber
                        size="small"
                        value={benne.prix_unitaire * benne.quantite}
                        disabled
                        style={{
                          width: "100%",
                          fontWeight: "bold",
                          background: "#f6ffed",
                          border: "1px solid #b7eb8f",
                        }}
                        formatter={spaceFmt}
                      />
                    </Col>
                  </Row>
                </div>
              ))}

            <Button
              type="dashed"
              size="small"
              onClick={addBenne}
              style={{ width: "50%", alignSelf: "center" }}
            >
              + Ajouter
            </Button>

            <Row justify="space-between" align="middle">
              <h5 style={{ margin: 0, fontSize: 14 }}>💰 Frais & Perdiems</h5>
              <Button type="primary" size="small" onClick={addFraisLine}>
                + Ajouter un frais
              </Button>
            </Row>

            {currentFrais &&
              currentFrais.map((frais, index) => (
                <div
                  key={index}
                  style={{
                    padding: 10,
                    borderRadius: 12,
                    border: "1px solid #f0f0f0",
                    background: "#fafafa",
                  }}
                >
                  <Row gutter={[10, 8]} align="middle">
                    <Col xs={24} md={7}>
                      <Select
                        size="small"
                        placeholder="Type de frais"
                        style={{ width: "100%" }}
                        value={frais.type}
                        onChange={(val) => updateFraisLine(index, "type", val)}
                      >
                        {fraisTypes.map((t) => (
                          <Option key={t.value} value={t.value}>
                            {t.label}
                          </Option>
                        ))}
                      </Select>
                    </Col>

                    <Col xs={12} md={6}>
                      <InputNumber
                        size="small"
                        min={0}
                        placeholder="Montant"
                        style={{ width: "100%" }}
                        value={frais.montant}
                        onChange={(val) => updateFraisLine(index, "montant", val)}
                        formatter={spaceFmt}
                      />
                    </Col>

                    <Col xs={12} md={3}>
                      <InputNumber
                        size="small"
                        min={1}
                        placeholder="N"
                        style={{ width: "100%" }}
                        value={frais.multiplicateur}
                        onChange={(val) =>
                          updateFraisLine(index, "multiplicateur", val)
                        }
                      />
                    </Col>

                    <Col xs={12} md={6}>
                      <InputNumber
                        size="small"
                        disabled
                        style={{
                          width: "100%",
                          fontWeight: "bold",
                          background: "#f6ffed",
                          border: "1px solid #b7eb8f",
                        }}
                        value={frais.total}
                        formatter={spaceFmt}
                      />
                    </Col>

                    <Col xs={12} md={2}>
                      <Button danger size="small" onClick={() => removeFraisLine(index)}>
                        ✕
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}
          </div>
        </div>
      </Modal>

      {showToast && <Notification message={notif.message} status={notif.info} />}
    </div>
  );
};

export default Devis;